import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Container, Row, Col, Card, Form, Button, Table, Spinner, Badge, Modal, ProgressBar, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function RekapPiutang() {
  const [typeprs, setTypeprs] = useState('1'); // 1 = Perusahaan Rekanan, 2 = Karyawan | Dokter
  const [kdprs, setKdprs] = useState('');
  const [nama, setNama] = useState('');
  
  const [dataPiutang, setDataPiutang] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [time, setTime] = useState({ date: '', clock: '' });
  const navigate = useNavigate();

  // Searchable Combobox State
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchPerusahaan, setSearchPerusahaan] = useState('');

  // Laporan Kartu & Buku Piutang Modal State
  const [showLaporanModal, setShowLaporanModal] = useState(false);
  const [laporanJenis, setLaporanJenis] = useState('buku'); // 'kartu' or 'buku'
  const [laporanJenisPiutang, setLaporanJenisPiutang] = useState('1'); // 1=Perusahaan, 2=Karyawan/Dokter, 3=Pribadi/Umum
  const [laporanDebitorSemua, setLaporanDebitorSemua] = useState(true);
  const [laporanDebitorKode, setLaporanDebitorKode] = useState('');
  const [laporanDebitorNama, setLaporanDebitorNama] = useState('');
  const [laporanPeriode1, setLaporanPeriode1] = useState(new Date().toISOString().split('T')[0]);
  const [laporanPeriode2, setLaporanPeriode2] = useState(new Date().toISOString().split('T')[0]);

  // Progress State
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressPercent, setProgressPercent] = useState(0);
  const [progressStatusText, setProgressStatusText] = useState('');

  // IN-APP PDF PREVIEW MODAL STATE
  const [showModalPdf, setShowModalPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfTitle, setPdfTitle] = useState('Laporan Piutang');
  const [isPdfFullscreen, setIsPdfFullscreen] = useState(false);
  const iframeRef = useRef(null);

  // State Toolbar Aksi Pelunasan (Sesuai Form Legacy)
  const [isProcessing, setIsProcessing] = useState(false);

  // Modal Saldo Pelunasan (Angsuran)
  const [showModalAngsuran, setShowModalAngsuran] = useState(false);
  const [listAngsuran, setListAngsuran] = useState([]);
  const [totalAngsuran, setTotalAngsuran] = useState(0);
  const [isAngsuranLoading, setIsAngsuranLoading] = useState(false);

  // ── Modern MessageBox State ──
  const [messageBox, setMessageBox] = useState({
    show: false,
    type: 'info', // 'warning' | 'danger' | 'success' | 'info' | 'confirm'
    title: '',
    message: '',
    confirmText: 'OK, Mengerti',
    cancelText: 'Batal',
    onConfirm: null,
    onCancel: null
  });

  const showMsg = (message, type = 'warning', title = null, onConfirm = null) => {
    let defaultTitle = 'Informasi';
    if (type === 'warning') defaultTitle = 'Peringatan';
    else if (type === 'danger' || type === 'error') defaultTitle = 'Terjadi Kesalahan';
    else if (type === 'success') defaultTitle = 'Berhasil';
    else if (type === 'confirm') defaultTitle = 'Konfirmasi Tindakan';

    setMessageBox({
      show: true,
      type: type === 'error' ? 'danger' : type,
      title: title || defaultTitle,
      message,
      confirmText: type === 'confirm' ? 'Ya, Lanjutkan' : 'OK, Mengerti',
      cancelText: 'Batal',
      onConfirm: onConfirm || null,
      onCancel: null
    });
  };

  const showConfirm = (message, onConfirm, title = 'Konfirmasi Tindakan') => {
    showMsg(message, 'confirm', title, onConfirm);
  };

  const closeMsg = () => {
    setMessageBox(prev => ({ ...prev, show: false }));
  };

  // Date Helpers
  const getFirstDayOfMonthYmd = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
  };
  const getTodayYmd = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  // Modal Laporan Proses Tagih Piutang (BPJS & Non-BPJS)
  const [showModalProsesTagih, setShowModalProsesTagih] = useState(false);
  const [periodeProsesTagih1, setPeriodeProsesTagih1] = useState(getFirstDayOfMonthYmd());
  const [periodeProsesTagih2, setPeriodeProsesTagih2] = useState(getTodayYmd());
  const [isProsesTagihLoading, setIsProsesTagihLoading] = useState(false);
  const [prosesTagihProgress, setProsesTagihProgress] = useState(0);
  const [prosesTagihStatusText, setProsesTagihStatusText] = useState('');
  const [prosesTagihResult, setProsesTagihResult] = useState(null);

  // Modal Cetak Summary Pelunasan
  const [showModalSummary, setShowModalSummary] = useState(false);
  const [periodeSummary1, setPeriodeSummary1] = useState(new Date().toISOString().split('T')[0]);
  const [periodeSummary2, setPeriodeSummary2] = useState(new Date().toISOString().split('T')[0]);

  const [showModalJurnalDibayar, setShowModalJurnalDibayar] = useState(false);
  const [periodeJurnal1, setPeriodeJurnal1] = useState(getFirstDayOfMonthYmd());
  const [periodeJurnal2, setPeriodeJurnal2] = useState(getTodayYmd());
  const [autoProcessJurnal, setAutoProcessJurnal] = useState(true);
  const [statusJurnalMsg, setStatusJurnalMsg] = useState('');
  const [isLoadingJurnal, setIsLoadingJurnal] = useState(false);
  const [jurnalDataResult, setJurnalDataResult] = useState(null);
  const [jurnalDownloadUrl, setJurnalDownloadUrl] = useState('');
  const [rekapJurnalKasirResult, setRekapJurnalKasirResult] = useState(null);
  const [rekapJurnalKasirDownloadUrl, setRekapJurnalKasirDownloadUrl] = useState('');

  const getApiUrl = () => {
    return localStorage.getItem('api_url') || 'http://localhost:8000';
  };

  const [listPerusahaan, setListPerusahaan] = useState([]);
  const [isLoadingPerusahaan, setIsLoadingPerusahaan] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchPerusahaan = async () => {
      setIsLoadingPerusahaan(true);
      try {
        const apiUrl = getApiUrl();
        const res = await fetch(`${apiUrl}/show_perusahaan`);
        if (res.ok) {
          const json = await res.json();
          let data = [];
          if (Array.isArray(json)) data = json;
          else if (json.data && Array.isArray(json.data)) data = json.data;
          else if (json.list_perusahaan) data = json.list_perusahaan;
          
          setListPerusahaan(data);
        }
      } catch (err) {
        console.error("Gagal mengambil data perusahaan:", err);
      } finally {
        setIsLoadingPerusahaan(false);
      }
    };
    fetchPerusahaan();
  }, []);

  const handleSelectPerusahaan = (valKd, valNama) => {
    setKdprs(valKd);
    setNama(valNama);
    setShowDropdown(false);
    setSearchPerusahaan('');
  };

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime({
        date: now.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
        clock: now.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  // Fetch Data Piutang
  const fetchPiutang = async (e) => {
    if (e) e.preventDefault();
    if (!kdprs) {
      showMsg('Pilih Perusahaan atau masukkan kode debitor terlebih dahulu!', 'warning', 'Pilih Debitor');
      return;
    }

    setIsLoading(true);
    setErrorMsg('');
    setDataPiutang([]);

    const apiUrl = getApiUrl();
    try {
      const res = await fetch(`${apiUrl}/show_piutang`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          typeprs: typeprs,
          kdprs: kdprs,
          nama: nama
        })
      });

      if (!res.ok) {
        throw new Error(`HTTP Error ${res.status}`);
      }

      const json = await res.json();
      if (Array.isArray(json)) {
        setDataPiutang(json);
      } else if (json.list_piutang && Array.isArray(json.list_piutang)) {
        setDataPiutang(json.list_piutang);
      } else if (json.data && Array.isArray(json.data)) {
        setDataPiutang(json.data);
      } else {
        setDataPiutang([]);
      }
    } catch (error) {
      console.error('Error fetching piutang:', error);
      setErrorMsg('Gagal mengambil data piutang. Pastikan backend aktif.');
    } finally {
      setIsLoading(false);
    }
  };

  // Handler Cetak & View Laporan In-App (No new browser tab)
  const handleCetakBukuPiutang = async () => {
    setShowLaporanModal(false);
    setShowProgressModal(true);
    setProgressPercent(15);
    setProgressStatusText('Menyiapkan parameter dan koneksi database...');
    
    let pVal = 15;
    const timer = setInterval(() => {
      pVal = Math.min(pVal + 15, 88);
      setProgressPercent(pVal);
      if (pVal > 30 && pVal <= 60) {
        setProgressStatusText('Menghitung saldo dan riwayat transaksi piutang...');
      } else if (pVal > 60) {
        setProgressStatusText('Mengompilasi dokumen PDF...');
      }
    }, 180);

    try {
      const payload = {
        jenis_laporan: laporanJenis,
        jenis_piutang: laporanJenisPiutang,
        semua_debitor: laporanDebitorSemua,
        kd_debitor: laporanDebitorKode,
        nm_debitor: laporanDebitorNama,
        periode1: laporanPeriode1,
        periode2: laporanPeriode2
      };
      
      const res = await fetch(`${getApiUrl()}/laporan_buku_piutang`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      
      const data = await res.json();
      
      clearInterval(timer);
      setProgressPercent(100);
      setProgressStatusText('Laporan berhasil disiapkan!');
      
      setTimeout(() => {
        setShowProgressModal(false);
        if (data.status === 1 && data.download_url) {
          const fullPdfUrl = getApiUrl() + data.download_url;
          setPdfUrl(fullPdfUrl);
          const titleLabel = laporanJenis === 'kartu' ? 'Laporan Kartu Piutang' : 'Laporan Buku Piutang';
          setPdfTitle(`${titleLabel} (Periode: ${laporanPeriode1} s/d ${laporanPeriode2})`);
          setShowModalPdf(true);
        } else {
          showMsg('Gagal membuat laporan: ' + (data.msg || 'Terjadi kesalahan'), 'danger', 'Gagal Membuat Laporan');
        }
      }, 350);
    } catch (err) {
      clearInterval(timer);
      setShowProgressModal(false);
      console.error(err);
      showMsg('Terjadi kesalahan saat memproses laporan ke server.', 'danger', 'Kesalahan Server');
    }
  };

  // Print direct from in-app iframe
  const handlePrintIframe = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.focus();
      iframeRef.current.contentWindow.print();
    }
  };

  const formatRp = (angka) => {
    if (!angka || isNaN(angka)) return 'Rp 0';
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(angka);
  };

  // Summary Metrics
  const summary = useMemo(() => {
    let totTagihan = 0;
    let totBayar = 0;
    let totSisa = 0;
    dataPiutang.forEach(item => {
      totTagihan += Number(item.total || 0);
      totBayar += Number(item.pembayaran || 0);
      totSisa += Number(item.saldo || item.sisa || 0);
    });
    return { totTagihan, totBayar, totSisa, count: dataPiutang.length };
  }, [dataPiutang]);

  // Format YYYY-MM-DD to DD/MM/YYYY
  const formatTgl = (tgl) => {
    if (!tgl) return '';
    if (tgl.includes('/')) return tgl;
    const parts = tgl.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return tgl;
  };

  // 1. PROSES PELUNASAN
  const executeProsesPelunasan = async () => {
    setIsProcessing(true);
    setShowProgressModal(true);
    setProgressPercent(15);
    setProgressStatusText('Menyiapkan proses pelunasan...');

    let pVal = 15;
    const timer = setInterval(() => {
      pVal = Math.min(pVal + 15, 85);
      setProgressPercent(pVal);
      if (pVal > 30 && pVal <= 60) {
        setProgressStatusText('Menghitung saldo dan mencocokkan angsuran kasir/bank...');
      } else if (pVal > 60) {
        setProgressStatusText('Memperbarui data buku pelunasan...');
      }
    }, 200);

    try {
      const res = await fetch(`${getApiUrl()}/prosestagih`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          txtkdprs: kdprs,
          txtnmprs: nama,
          cmbtypejamin: typeprs
        })
      });

      const json = await res.json();
      clearInterval(timer);
      setProgressPercent(100);
      setProgressStatusText('Proses pelunasan selesai!');

      setTimeout(() => {
        setShowProgressModal(false);
        setIsProcessing(false);
        if (json.status === 1) {
          showMsg(json.msg || 'Proses pelunasan berhasil diselesaikan!', 'success', 'Pelunasan Berhasil');
          fetchPiutang();
        } else {
          showMsg('Gagal memproses pelunasan: ' + (json.msg || 'Terjadi kesalahan'), 'danger', 'Gagal Pelunasan');
        }
      }, 350);
    } catch (err) {
      clearInterval(timer);
      setShowProgressModal(false);
      setIsProcessing(false);
      console.error(err);
      showMsg('Terjadi kesalahan koneksi saat memproses pelunasan.', 'danger', 'Kesalahan Koneksi');
    }
  };

  const handleProsesPelunasan = () => {
    if (!kdprs) {
      showMsg('Pilih Perusahaan / Debitor terlebih dahulu!', 'warning', 'Pilih Debitor');
      return;
    }
    if (dataPiutang.length === 0) {
      showMsg('Tidak ada data piutang untuk diproses!', 'warning', 'Data Piutang Kosong');
      return;
    }
    showConfirm(
      `Yakin ingin memproses pelunasan untuk debitor [${kdprs}] ${nama || ''}?`,
      () => executeProsesPelunasan(),
      'Konfirmasi Pelunasan'
    );
  };

  const formatAngka = (val) => {
    if (!val || isNaN(val)) return '0';
    return new Intl.NumberFormat('en-US').format(Math.round(val));
  };

  // 2. SALDO PELUNASAN
  const handleShowAngsuran = async () => {
    if (!kdprs) {
      showMsg('Pilih Perusahaan / Debitor terlebih dahulu!', 'warning', 'Pilih Debitor');
      return;
    }

    setShowModalAngsuran(true);
    setIsAngsuranLoading(true);
    try {
      const res = await fetch(`${getApiUrl()}/show_angsuran`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jenisjaminan: typeprs,
          kdprs: kdprs,
          txtkdprs: kdprs,
          cmbtypejamin: typeprs
        })
      });
      const json = await res.json();
      const rawList = json.list_angsuran || json.data || [];
      const list = Array.isArray(rawList) ? rawList : [];
      setListAngsuran(list);
      const total = json.total_angsuran !== undefined ? Number(json.total_angsuran) : list.reduce((acc, curr) => acc + Number(curr.pembayaran || 0), 0);
      setTotalAngsuran(total);

    } catch (err) {
      console.error(err);
      showMsg('Terjadi kesalahan saat memuat data saldo angsuran.', 'danger', 'Gagal Memuat Saldo');
      setListAngsuran([]);
      setTotalAngsuran(0);
    } finally {
      setIsAngsuranLoading(false);
    }
  };

  // Cetak Saldo Dialog
  const handleCetakSaldo = () => {
    if (listAngsuran.length === 0) {
      showMsg('Tidak ada data saldo pelunasan untuk dicetak!', 'warning', 'Data Kosong');
      return;
    }
    const win = window.open('', '_blank');
    if (!win) {
      showMsg('Izinkan pop-up browser untuk mencetak saldo!', 'info', 'Pengaturan Browser');
      return;
    }
    win.document.write(`
      <html>
        <head>
          <title>Saldo Penerimaan Pelunasan Piutang</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; font-size: 12px; color: #000; }
            h3 { text-align: center; margin-bottom: 4px; color: #002d38; text-transform: uppercase; letter-spacing: 0.5px; }
            p { text-align: center; margin-top: 0; color: #555; font-size: 11px; }
            table { width: 100%; border-collapse: collapse; margin-top: 15px; }
            th { background-color: #008080; color: white; padding: 7px 10px; border: 1px solid #333; text-align: center; font-size: 11px; font-weight: bold; }
            td { padding: 6px 10px; border: 1px solid #999; font-size: 11px; }
            .text-end { text-align: right; }
            .text-center { text-align: center; }
            .fw-bold { font-weight: bold; }
            .saldo-wrap { margin-top: 15px; display: flex; justify-content: flex-end; }
            .saldo-label { background: #004785; color: white; padding: 5px 15px; font-weight: bold; border: 1px solid #002d5a; }
            .saldo-val { background: #1e293b; color: #22c55e; padding: 5px 15px; font-weight: bold; font-family: monospace; border: 1px solid #0f172a; min-width: 120px; text-align: right; }
          </style>
        </head>
        <body>
          <h3>SALDO PENERIMAAN PELUNASAN PIUTANG</h3>
          <p>Debitor: [${kdprs}] ${nama || '-'} | Waktu Cetak: ${new Date().toLocaleString('id-ID')}</p>
          <table>
            <thead>
              <tr>
                <th>NOMOR PELUNASAN</th>
                <th>TANGGAL BANK</th>
                <th>NOMOR REKENING</th>
                <th>BANK</th>
                <th>NILAI [Rp]</th>
              </tr>
            </thead>
            <tbody>
              ${listAngsuran.map(item => `
                <tr>
                  <td class="fw-bold">${item.no_pelunasan || '-'}</td>
                  <td class="text-center">${item.tgl_bank || '-'}</td>
                  <td class="fw-bold">${item.no_rekening || '-'}</td>
                  <td class="fw-bold">${item.nm_bank || '-'}</td>
                  <td class="text-end fw-bold">${formatAngka(item.pembayaran)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          <div class="saldo-wrap">
            <span class="saldo-label">SALDO [Rp]</span>
            <span class="saldo-val">${formatAngka(totalAngsuran)}</span>
          </div>
          <script>window.print();</script>
        </body>
      </html>
    `);
    win.document.close();
  };

  // ── HANDLER LAPORAN PROSES TAGIH PIUTANG (BPJS & NON-BPJS) ──
  const handleEksekusiProsesTagih = async () => {
    if (!periodeProsesTagih1 || !periodeProsesTagih2) {
      showMsg('Periode tanggal tagihan awal dan akhir wajib diisi!', 'warning', 'Periode Belum Lengkap');
      return;
    }

    setIsProsesTagihLoading(true);
    setProsesTagihProgress(20);
    setProsesTagihStatusText('Memeriksa kuitansi tagihan dan sinkronisasi piutang...');
    setProsesTagihResult(null);

    try {
      setProsesTagihProgress(50);
      setProsesTagihStatusText('Menyusun data tagihan Non-BPJS & BPJS...');

      const apiUrl = getApiUrl();
      const res = await fetch(`${apiUrl}/laporan_proses_tagih_piutang`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          periode1: periodeProsesTagih1,
          periode2: periodeProsesTagih2
        })
      });

      setProsesTagihProgress(85);
      setProsesTagihStatusText('Menyelesaikan berkas PDF dan lembar kerja Excel...');

      const json = await res.json();
      if (res.ok && json.status === 1) {
        setProsesTagihProgress(100);
        setProsesTagihStatusText('Proses selesai! 2 Laporan berhasil dibuat.');
        setProsesTagihResult(json);
        const nonBpjsNominal = (json.non_bpjs?.total_nominal || 0).toLocaleString('id-ID');
        const bpjsNominal = (json.bpjs?.total_nominal || 0).toLocaleString('id-ID');
        showMsg(
          `Laporan Proses Tagih Piutang berhasil disusun!\n\n` +
          `• Non-BPJS: ${json.non_bpjs?.count_kuitansi || 0} Kuitansi, ${json.non_bpjs?.count_transaksi || 0} Transaksi (Rp ${nonBpjsNominal})\n` +
          `• BPJS: ${json.bpjs?.count_kuitansi || 0} Kuitansi, ${json.bpjs?.count_transaksi || 0} Transaksi (Rp ${bpjsNominal})`,
          'success',
          'Proses Berhasil Selesai'
        );
      } else {
        throw new Error(json.msg || 'Gagal memproses laporan tagihan');
      }
    } catch (err) {
      console.error(err);
      showMsg(err.message || 'Terjadi kesalahan saat memproses laporan.', 'danger', 'Kesalahan Server');
      setProsesTagihStatusText('Gagal memproses laporan.');
    } finally {
      setIsProsesTagihLoading(false);
    }
  };

  const handlePreviewPdfTagih = (type) => {
    if (!prosesTagihResult) return;
    const apiUrl = getApiUrl();
    if (type === 'non_bpjs' && prosesTagihResult.non_bpjs?.pdf_url) {
      setPdfTitle(`Laporan Proses Tagih Piutang (Non-BPJS) - Periode ${prosesTagihResult.periode?.periode1} s/d ${prosesTagihResult.periode?.periode2}`);
      setPdfUrl(`${apiUrl}${prosesTagihResult.non_bpjs.pdf_url}`);
      setShowModalPdf(true);
    } else if (type === 'bpjs' && prosesTagihResult.bpjs?.pdf_url) {
      setPdfTitle(`Laporan Proses Tagih Piutang (BPJS) - Periode ${prosesTagihResult.periode?.periode1} s/d ${prosesTagihResult.periode?.periode2}`);
      setPdfUrl(`${apiUrl}${prosesTagihResult.bpjs.pdf_url}`);
      setShowModalPdf(true);
    }
  };

  const handleDownloadExcelTagih = (type) => {
    if (!prosesTagihResult) return;
    const apiUrl = getApiUrl();
    const url = type === 'non_bpjs' ? prosesTagihResult.non_bpjs?.excel_url : prosesTagihResult.bpjs?.excel_url;
    if (url) {
      window.open(`${apiUrl}${url}`, '_blank');
    }
  };

  // 3. CETAK SUMMARY PELUNASAN
  const handleProsesCetakSummary = async () => {
    setShowModalSummary(false);
    setShowProgressModal(true);
    setProgressPercent(20);
    setProgressStatusText('Menyiapkan dokumen Summary Pelunasan...');

    let pVal = 20;
    const timer = setInterval(() => {
      pVal = Math.min(pVal + 15, 85);
      setProgressPercent(pVal);
      if (pVal > 40 && pVal <= 70) {
        setProgressStatusText('Mengambil rekap mutasi angsuran debitor...');
      } else if (pVal > 70) {
        setProgressStatusText('Menyusun halaman laporan PDF...');
      }
    }, 200);

    try {
      const res = await fetch(`${getApiUrl()}/cetak_summary_pelunasan`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          kdprs: kdprs || '',
          typeprs: typeprs,
          periode1: formatTgl(periodeSummary1),
          periode2: formatTgl(periodeSummary2)
        })
      });

      if (!res.ok) {
        const textErr = await res.text();
        throw new Error(textErr || 'Gagal membuat dokumen summary');
      }

      const blob = await res.blob();
      clearInterval(timer);
      setProgressPercent(100);
      setProgressStatusText('Summary Pelunasan siap!');

      setTimeout(() => {
        setShowProgressModal(false);
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
        setPdfTitle(`Summary Pelunasan (${formatTgl(periodeSummary1)} s/d ${formatTgl(periodeSummary2)})`);
        setShowModalPdf(true);
      }, 350);
    } catch (err) {
      clearInterval(timer);
      setShowProgressModal(false);
      console.error(err);
      showMsg('Gagal mencetak summary: ' + err.message, 'danger', 'Gagal Mencetak');
    }
  };

  // 4. CETAK REKAPITULASI
  const handleCetakRekapitulasi = async () => {
    if (!kdprs) {
      showMsg('Pilih Perusahaan / Debitor terlebih dahulu untuk mencetak rekapitulasi!', 'warning', 'Pilih Debitor');
      return;
    }

    setShowProgressModal(true);
    setProgressPercent(20);
    setProgressStatusText('Menyiapkan dokumen Rekapitulasi Piutang...');

    let pVal = 20;
    const timer = setInterval(() => {
      pVal = Math.min(pVal + 15, 85);
      setProgressPercent(pVal);
      if (pVal > 40 && pVal <= 70) {
        setProgressStatusText('Merekap seluruh transaksi & pembayaran...');
      } else if (pVal > 70) {
        setProgressStatusText('Mengompilasi dokumen PDF...');
      }
    }, 200);

    try {
      const res = await fetch(`${getApiUrl()}/cetak_rekapitulasi_piutang`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          kdprs: kdprs,
          typeprs: typeprs
        })
      });

      if (!res.ok) {
        const textErr = await res.text();
        throw new Error(textErr || 'Gagal membuat dokumen rekapitulasi');
      }

      const blob = await res.blob();
      clearInterval(timer);
      setProgressPercent(100);
      setProgressStatusText('Rekapitulasi Piutang siap!');

      setTimeout(() => {
        setShowProgressModal(false);
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
        setPdfTitle(`Rekapitulasi Piutang - [${kdprs}] ${nama || ''}`);
        setShowModalPdf(true);
      }, 350);
    } catch (err) {
      clearInterval(timer);
      setShowProgressModal(false);
      console.error(err);
      showMsg('Gagal mencetak rekapitulasi: ' + err.message, 'danger', 'Gagal Mencetak');
    }
  };

  // 5. BERSIH
  const handleBersih = () => {
    setKdprs('');
    setNama('');
    setSearchPerusahaan('');
    setDataPiutang([]);
    setErrorMsg('');
  };

  // 6. LAPORAN JURNAL DIBAYAR & LAPORAN JURNAL TERHUTANG
  const triggerDownloadJurnal = (url, filename) => {
    const apiUrl = getApiUrl() || 'http://localhost:8000';
    const fileUrl = url.startsWith('http') ? url : `${apiUrl}${url.startsWith('/') ? '' : '/'}${url}`;
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = filename || 'Laporan_Jurnal_Dibayar.xlsx';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const handleLaporanJurnalDibayar = () => {
    if (!periodeJurnal1) setPeriodeJurnal1(getFirstDayOfMonthYmd());
    if (!periodeJurnal2) setPeriodeJurnal2(getTodayYmd());
    setStatusJurnalMsg('');
    setShowModalJurnalDibayar(true);
  };

  const handleFetchJurnalDibayar = async (isDownloadOnly = false) => {
    setIsLoadingJurnal(true);
    setStatusJurnalMsg('1/2: Memproses Laporan Jurnal Pengeluaran (Dibayar)...');
    const apiUrl = getApiUrl() || 'http://localhost:8000';
    const token = localStorage.getItem('token');

    const p1 = formatTgl(periodeJurnal1);
    const p2 = formatTgl(periodeJurnal2);

    const payload = {
      periode1: p1,
      periode2: p2,
      auto_process: autoProcessJurnal
    };

    try {
      // 1. Jalankan Laporan Jurnal Pengeluaran / Dibayar
      const res1 = await fetch(`${apiUrl}/laporan_jurnal_dibayar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify(payload)
      });

      const data1 = await res1.json();
      let dlUrl1 = '';
      if (res1.ok && (data1.status === 1 || data1.download_url || data1.groups)) {
        setJurnalDataResult(data1);
        if (data1.download_url) {
          dlUrl1 = data1.download_url;
          setJurnalDownloadUrl(data1.download_url);
        }
      } else {
        throw new Error(data1.msg || data1.message || 'Gagal memproses Laporan Jurnal Dibayar');
      }

      // 2. Lanjutkan otomatis ke Laporan Rekapitulasi Jurnal Kasir (prnjrnksr)
      setStatusJurnalMsg('2/2: Melanjutkan proses Laporan Rekapitulasi Jurnal Kasir...');
      
      const payloadRekapKasir = {
        periode1: p1,
        periode2: p2,
        auto_process: false // Sudah di-auto-process pada tahap 1
      };

      const res2 = await fetch(`${apiUrl}/laporan_rekap_jurnal_kasir`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify(payloadRekapKasir)
      });

      const data2 = await res2.json();
      let dlUrl2 = '';
      if (res2.ok && (data2.status === 1 || data2.items || data2.download_url)) {
        setRekapJurnalKasirResult(data2);
        if (data2.download_url) {
          dlUrl2 = data2.download_url;
          setRekapJurnalKasirDownloadUrl(data2.download_url);
        }
      }

      setStatusJurnalMsg(`Selesai: Jurnal Pengeluaran (${data1.count || 0}) & Rekap Kasir (${data2?.count || 0}) berhasil disusun!`);

      // Jika user menekan tombol unduh excel langsung
      if (isDownloadOnly) {
        const file1 = `Jurnal_Pengeluaran_${p1.replace(/\//g, '')}_sd_${p2.replace(/\//g, '')}.xlsx`;
        const file2 = `Rekap_Jurnal_Kasir_${p1.replace(/\//g, '')}_sd_${p2.replace(/\//g, '')}.xlsx`;
        if (dlUrl1) triggerDownloadJurnal(dlUrl1, file1);
        if (dlUrl2) setTimeout(() => triggerDownloadJurnal(dlUrl2, file2), 700);
      }
    } catch (err) {
      console.error(err);
      setStatusJurnalMsg('Error: ' + err.message);
    } finally {
      setIsLoadingJurnal(false);
    }
  };

  const handleUnduhExcelJurnal = () => {
    const p1 = formatTgl(periodeJurnal1).replace(/\//g, '');
    const p2 = formatTgl(periodeJurnal2).replace(/\//g, '');
    if (jurnalDownloadUrl) {
      triggerDownloadJurnal(jurnalDownloadUrl, `Jurnal_Pengeluaran_${p1}_sd_${p2}.xlsx`);
    }
    if (rekapJurnalKasirDownloadUrl) {
      setTimeout(() => {
        triggerDownloadJurnal(rekapJurnalKasirDownloadUrl, `Rekap_Jurnal_Kasir_${p1}_sd_${p2}.xlsx`);
      }, 700);
    }
    if (!jurnalDownloadUrl && !rekapJurnalKasirDownloadUrl) {
      handleFetchJurnalDibayar(true);
    }
  };

  const handleLaporanJurnalTerhutang = () => {
    showMsg(`Laporan Jurnal Terhutang untuk ${kdprs ? `perusahaan [${kdprs}] ${nama || ''}` : 'seluruh transaksi'} akan diproses.`, 'info', 'Jurnal Terhutang');
  };

  // Button styles matching the uploaded image
  const vbBtnStyle = {
    background: 'linear-gradient(180deg, #ffffff 0%, #f1f5f9 40%, #e2e8f0 100%)',
    border: '1px solid #94a3b8',
    color: '#0f172a',
    fontSize: '0.78rem',
    fontWeight: '700',
    padding: '4px 10px',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.8), 0 1px 2px rgba(0,0,0,0.06)',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    letterSpacing: '0.2px',
    transition: 'all 0.15s ease'
  };

  const vbBtnBersihStyle = {
    ...vbBtnStyle,
    background: 'linear-gradient(180deg, #ffffff 0%, #f1f5f9 40%, #e2e8f0 100%)',
    border: '1px solid #94a3b8',
    padding: '4px 14px'
  };

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', paddingBottom: '3rem' }}>
      {/* Top Navbar */}
      <nav className="navbar navbar-expand px-4 py-2 text-white shadow-sm" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', borderBottom: '2px solid #3b82f6' }}>
        <div className="container-fluid p-0 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <div className="rounded-3 p-2 d-flex align-items-center justify-content-center bg-primary bg-opacity-25 border border-primary border-opacity-50">
              <i className="bi bi-wallet2 text-warning fs-5"></i>
            </div>
            <div>
              <span className="fw-bold fs-6 tracking-wide d-block text-white">SIMRS — Rekapitulasi Piutang & Kartu Piutang</span>
              <span className="text-light text-opacity-75" style={{ fontSize: '0.72rem' }}>
                <i className="bi bi-shield-check text-success me-1"></i>Modul Keuangan & Penagihan Terpadu
              </span>
            </div>
          </div>
          
          <div className="d-flex align-items-center gap-3">
            <div className="text-end d-none d-md-block px-3 py-1 rounded bg-dark bg-opacity-50 border border-secondary border-opacity-25" style={{ fontSize: '0.75rem' }}>
              <div className="text-light fw-medium"><i className="bi bi-calendar3 me-1 text-info"></i>{time.date}</div>
              <div className="text-warning fw-bold"><i className="bi bi-clock me-1"></i>{time.clock} WIB</div>
            </div>
            <Button
              variant="outline-light"
              size="sm"
              className="fw-semibold shadow-sm d-flex align-items-center gap-2 px-3 py-1"
              style={{ fontSize: '0.78rem', borderRadius: '8px' }}
              onClick={() => navigate('/home')}
            >
              <i className="bi bi-house-door-fill text-warning"></i> Menu Utama
            </Button>
          </div>
        </div>
      </nav>
      
      <Container fluid className="mt-2 px-3">
        {/* Header Action Bar */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
          <div>
            <h6 className="fw-bold mb-0 text-dark d-flex align-items-center gap-2" style={{ fontSize: '0.9rem' }}>
              <i className="bi bi-journal-bookmark-fill text-primary"></i>
              Daftar Tagihan & Rekap Piutang
            </h6>
            <span className="text-muted" style={{ fontSize: '0.75rem' }}>
              Pencarian, pemantauan saldo, dan cetak laporan kartu piutang debitor
            </span>
          </div>
          <div className="d-flex gap-2 flex-wrap">
            <Button 
              variant="info" 
              size="sm" 
              className="fw-semibold shadow-sm d-flex align-items-center gap-2 px-3 rounded-2 text-white"
              style={{ fontSize: '0.78rem', background: '#002f3d', borderColor: '#001f29' }}
              onClick={() => {
                const today = new Date().toISOString().split('T')[0];
                if (!periodeProsesTagih1) setPeriodeProsesTagih1(getFirstDayOfMonthYmd());
                if (!periodeProsesTagih2) setPeriodeProsesTagih2(today);
                setShowModalProsesTagih(true);
              }}
            >
              <i className="bi bi-file-earmark-text-fill text-warning"></i>
              Laporan Proses Tagih Piutang
            </Button>
            <Button 
              variant="primary" 
              size="sm" 
              className="fw-semibold shadow-sm d-flex align-items-center gap-2 px-3 rounded-2"
              style={{ fontSize: '0.78rem' }}
              onClick={() => setShowLaporanModal(true)}
            >
              <i className="bi bi-file-earmark-pdf-fill text-warning"></i>
              Cetak & View Laporan Piutang
            </Button>
            <Button 
              variant="success" 
              size="sm" 
              className="fw-semibold shadow-sm d-flex align-items-center gap-2 px-3 rounded-2"
              style={{ fontSize: '0.78rem' }}
              onClick={handleLaporanJurnalDibayar}
            >
              <i className="bi bi-journal-check"></i>
              Laporan Jurnal Dibayar
            </Button>
            <Button 
              variant="warning" 
              size="sm" 
              className="fw-semibold shadow-sm d-flex align-items-center gap-2 px-3 rounded-2 text-dark"
              style={{ fontSize: '0.78rem' }}
              onClick={handleLaporanJurnalTerhutang}
            >
              <i className="bi bi-journal-text"></i>
              Laporan Jurnal Terhutang
            </Button>
          </div>
        </div>

        {/* Summary Stat Cards */}
        <Row className="g-2 mb-2">
          <Col md={3} sm={6}>
            <Card className="border-0 shadow-sm rounded-3 h-100 bg-white">
              <Card.Body className="px-3 py-2 d-flex align-items-center justify-content-between">
                <div>
                  <span className="text-muted fw-semibold d-block text-uppercase" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Total Tagihan</span>
                  <h6 className="fw-bold mb-0 text-primary mt-1" style={{ fontSize: '0.9rem' }}>{formatRp(summary.totTagihan)}</h6>
                  <span className="text-muted" style={{ fontSize: '0.65rem' }}>{summary.count} data transaksi</span>
                </div>
                <div className="p-2 rounded-circle bg-primary bg-opacity-10 text-primary">
                  <i className="bi bi-receipt fs-5"></i>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3} sm={6}>
            <Card className="border-0 shadow-sm rounded-3 h-100 bg-white">
              <Card.Body className="px-3 py-2 d-flex align-items-center justify-content-between">
                <div>
                  <span className="text-muted fw-semibold d-block text-uppercase" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Total Terbayar</span>
                  <h6 className="fw-bold mb-0 text-success mt-1" style={{ fontSize: '0.9rem' }}>{formatRp(summary.totBayar)}</h6>
                  <span className="text-success" style={{ fontSize: '0.65rem' }}><i className="bi bi-check-circle me-1"></i>Pelunasan Masuk</span>
                </div>
                <div className="p-2 rounded-circle bg-success bg-opacity-10 text-success">
                  <i className="bi bi-cash-stack fs-5"></i>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3} sm={6}>
            <Card className="border-0 shadow-sm rounded-3 h-100 bg-white">
              <Card.Body className="px-3 py-2 d-flex align-items-center justify-content-between">
                <div>
                  <span className="text-muted fw-semibold d-block text-uppercase" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Sisa Piutang / Saldo</span>
                  <h6 className="fw-bold mb-0 text-danger mt-1" style={{ fontSize: '0.9rem' }}>{formatRp(summary.totSisa)}</h6>
                  <span className="text-danger" style={{ fontSize: '0.65rem' }}><i className="bi bi-clock-history me-1"></i>Belum Terbayar</span>
                </div>
                <div className="p-2 rounded-circle bg-danger bg-opacity-10 text-danger">
                  <i className="bi bi-hourglass-split fs-5"></i>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3} sm={6}>
            <Card className="border-0 shadow-sm rounded-3 h-100 bg-white">
              <Card.Body className="px-3 py-2 d-flex align-items-center justify-content-between">
                <div>
                  <span className="text-muted fw-semibold d-block text-uppercase" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Debitor Terpilih</span>
                  <h6 className="fw-bold mb-0 text-dark text-truncate mt-1" style={{ maxWidth: '160px', fontSize: '0.85rem' }}>{nama || kdprs || '-'}</h6>
                  <span className="text-muted" style={{ fontSize: '0.65rem' }}>Kode: {kdprs || '-'}</span>
                </div>
                <div className="p-2 rounded-circle bg-info bg-opacity-10 text-info">
                  <i className="bi bi-building fs-5"></i>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Filter Card */}
        <Card className="shadow-sm border-0 mb-2 rounded-3 bg-white">
          <Card.Header className="bg-white py-2 px-3 border-bottom d-flex align-items-center justify-content-between" style={{ minHeight: 'auto' }}>
            <span className="fw-bold text-dark d-flex align-items-center gap-2" style={{ fontSize: '0.82rem' }}>
              <i className="bi bi-sliders text-primary"></i> Filter & Parameter Debitor
            </span>
            <Badge bg={typeprs === '1' ? 'primary' : 'success'} className="px-2 py-1 fw-normal" style={{ fontSize: '0.7rem' }}>
              {typeprs === '1' ? 'Perusahaan Rekanan' : 'Karyawan / Dokter'}
            </Badge>
          </Card.Header>
          <Card.Body className="px-3 py-2">
            <Form onSubmit={fetchPiutang}>
              <Row className="g-2 align-items-end">
                <Col lg={3} md={4}>
                  <Form.Group>
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.75rem' }}>
                      <i className="bi bi-tags me-1"></i>Tipe Piutang
                    </Form.Label>
                    <Form.Select 
                      size="sm" 
                      value={typeprs} 
                      onChange={(e) => setTypeprs(e.target.value)}
                      className="form-select-sm rounded-2"
                      style={{ fontSize: '0.82rem' }}
                    >
                      <option value="1">1 — Perusahaan Rekanan / Asuransi</option>
                      <option value="2">2 — Karyawan | Dokter</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col lg={4} md={4}>
                  <Form.Group>
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.75rem' }}>
                      <i className="bi bi-search me-1"></i>Pilih Perusahaan / Debitor {isLoadingPerusahaan && <Spinner size="sm" animation="border" className="ms-1" />}
                    </Form.Label>
                    <div className="position-relative" ref={dropdownRef}>
                      <div 
                        className="form-control form-control-sm d-flex justify-content-between align-items-center py-2 rounded-2" 
                        onClick={() => setShowDropdown(!showDropdown)}
                        style={{ backgroundColor: '#fff', cursor: 'pointer', fontSize: '0.85rem' }}
                      >
                        <span className="text-truncate fw-medium text-dark">
                          {kdprs ? `${kdprs} — ${nama}` : '-- Cari / Pilih Perusahaan --'}
                        </span>
                        <i className="bi bi-chevron-down ms-2 text-muted"></i>
                      </div>
                      
                      {showDropdown && (
                        <div className="dropdown-menu show w-100 p-2 shadow-lg border-0 rounded-3 mt-1" style={{ maxHeight: '320px', overflowY: 'auto', position: 'absolute', zIndex: 1050, top: '100%', left: 0 }}>
                          <InputGroup size="sm" className="mb-2">
                            <InputGroup.Text className="bg-light border-end-0"><i className="bi bi-search text-muted"></i></InputGroup.Text>
                            <Form.Control
                              autoFocus
                              placeholder="Ketik nama atau kode debitor..."
                              value={searchPerusahaan}
                              onChange={(e) => setSearchPerusahaan(e.target.value)}
                              className="border-start-0"
                              style={{ fontSize: '0.82rem' }}
                            />
                            {searchPerusahaan && (
                              <Button variant="outline-secondary" onClick={() => setSearchPerusahaan('')}>
                                <i className="bi bi-x"></i>
                              </Button>
                            )}
                          </InputGroup>
                          {listPerusahaan.filter(p => {
                            const valKd = String(p.kode || p.kd_pj || p.kd_prs || p.kode_perusahaan || p.id || p.kdprs || Object.values(p)[0] || '').toLowerCase();
                            const valNama = String(p.perusahaan || p.png_jawab || p.nama_perusahaan || p.nama_prs || p.nama || Object.values(p)[1] || '').toLowerCase();
                            const search = searchPerusahaan.toLowerCase();
                            return valKd.includes(search) || valNama.includes(search);
                          }).length === 0 ? (
                            <div className="text-center text-muted p-3" style={{ fontSize: '0.8rem' }}>
                              <i className="bi bi-search d-block mb-1 fs-5"></i>
                              Debitor tidak ditemukan
                            </div>
                          ) : (
                            listPerusahaan.filter(p => {
                              const valKd = String(p.kode || p.kd_pj || p.kd_prs || p.kode_perusahaan || p.id || p.kdprs || Object.values(p)[0] || '').toLowerCase();
                              const valNama = String(p.perusahaan || p.png_jawab || p.nama_perusahaan || p.nama_prs || p.nama || Object.values(p)[1] || '').toLowerCase();
                              const search = searchPerusahaan.toLowerCase();
                              return valKd.includes(search) || valNama.includes(search);
                            }).map((p, idx) => {
                              const valKd = p.kode || p.kd_pj || p.kd_prs || p.kode_perusahaan || p.id || p.kdprs || Object.values(p)[0] || `UNK-${idx}`;
                              const valNama = p.perusahaan || p.png_jawab || p.nama_perusahaan || p.nama_prs || p.nama || Object.values(p)[1] || 'Tanpa Nama';
                              const isSelected = kdprs === valKd;
                              return (
                                <div 
                                  key={idx} 
                                  className={`dropdown-item rounded-2 d-flex align-items-center justify-content-between my-1 ${isSelected ? 'bg-primary text-white' : 'hover-bg-light'}`}
                                  style={{ cursor: 'pointer', fontSize: '0.8rem', padding: '0.5rem 0.75rem', whiteSpace: 'normal' }}
                                  onClick={() => handleSelectPerusahaan(valKd, valNama)}
                                >
                                  <div>
                                    <span className={`fw-bold ${isSelected ? 'text-white' : 'text-primary'}`}>[{valKd}]</span> {valNama}
                                  </div>
                                  {isSelected && <i className="bi bi-check2 text-white"></i>}
                                </div>
                              );
                            })
                          )}
                        </div>
                      )}
                    </div>
                  </Form.Group>
                </Col>

                <Col lg={3} md={4}>
                  <Form.Group>
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.8rem' }}>
                      <i className="bi bi-card-heading me-1"></i>Nama Debitor
                    </Form.Label>
                    <Form.Control 
                      size="sm" 
                      type="text" 
                      placeholder="Nama debitor otomatis" 
                      value={nama} 
                      onChange={(e) => setNama(e.target.value)}
                      className="py-2 rounded-2"
                      style={{ fontSize: '0.85rem' }}
                    />
                  </Form.Group>
                </Col>

                <Col lg={2} md={12} className="d-flex gap-2">
                  <Button 
                    type="submit" 
                    variant="primary" 
                    size="sm" 
                    className="w-100 fw-bold py-2 rounded-2 d-flex align-items-center justify-content-center gap-2 shadow-sm"
                    disabled={isLoading}
                  >
                    {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-search"></i>}
                    Tampilkan
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        {/* Action Button Bar sesuai gambar (PROSES PELUNASAN, SALDO PELUNASAN, CETAK SUMMARY PELUNASAN, CETAK REKAPITULASI, BERSIH) */}
        <div 
          className="p-2 mb-2 rounded border shadow-sm d-flex flex-wrap align-items-center justify-content-between gap-2"
          style={{ 
            background: 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
            borderColor: '#cbd5e1'
          }}
        >
          <div className="d-flex flex-wrap align-items-center gap-2">
            {/* 1. PROSES PELUNASAN */}
            <button
              type="button"
              disabled={isLoading || isProcessing}
              onClick={handleProsesPelunasan}
              style={vbBtnStyle}
              title="Proses Pelunasan Piutang Debitor"
            >
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-1">
                <circle cx="12" cy="3" r="2" fill="#2563eb" opacity="0.35"/>
                <circle cx="18.36" cy="5.64" r="2.2" fill="#2563eb" opacity="0.5"/>
                <circle cx="21" cy="12" r="2.4" fill="#2563eb" opacity="0.65"/>
                <circle cx="18.36" cy="18.36" r="2.6" fill="#2563eb" opacity="0.8"/>
                <circle cx="12" cy="21" r="2.8" fill="#1d4ed8"/>
                <circle cx="5.64" cy="18.36" r="2.6" fill="#2563eb" opacity="0.8"/>
                <circle cx="3" cy="12" r="2.2" fill="#2563eb" opacity="0.5"/>
                <circle cx="5.64" cy="5.64" r="2" fill="#2563eb" opacity="0.35"/>
              </svg>
              <span><u>P</u>ROSES PELUNASAN</span>
            </button>

            {/* 2. SALDO PELUNASAN */}
            <button
              type="button"
              disabled={isLoading || isProcessing}
              onClick={handleShowAngsuran}
              style={vbBtnStyle}
              title="Lihat Rincian Saldo Pelunasan & Angsuran"
            >
              <span className="d-inline-flex align-items-center justify-content-center p-1 rounded bg-white border" style={{ borderColor: '#94a3b8', lineHeight: 1 }}>
                <i className="bi bi-window-sidebar" style={{ color: '#0284c7', fontSize: '0.85rem' }}></i>
              </span>
              <span><u>S</u>ALDO PELUNASAN</span>
            </button>

            {/* 3. CETAK SUMMARY PELUNASAN */}
            <button
              type="button"
              disabled={isLoading || isProcessing}
              onClick={() => {
                const today = new Date().toISOString().split('T')[0];
                if (!periodeSummary1) setPeriodeSummary1(today);
                if (!periodeSummary2) setPeriodeSummary2(today);
                setShowModalSummary(true);
              }}
              style={vbBtnStyle}
              title="Cetak Summary Pelunasan Bank"
            >
              <i className="bi bi-printer text-dark fs-6"></i>
              <span><u>C</u>ETAK SUMMARY PELUNASAN</span>
            </button>

            {/* 4. CETAK REKAPITULASI */}
            <button
              type="button"
              disabled={isLoading || isProcessing}
              onClick={handleCetakRekapitulasi}
              style={vbBtnStyle}
              title="Cetak Dokumen Rekapitulasi Piutang"
            >
              <i className="bi bi-printer-fill text-dark fs-6"></i>
              <span><u>C</u>ETAK REKAPITULASI</span>
            </button>

            {/* 5. LAPORAN PROSES TAGIH PIUTANG */}
            <button
              type="button"
              disabled={isLoading || isProcessing}
              onClick={() => {
                const today = new Date().toISOString().split('T')[0];
                if (!periodeProsesTagih1) setPeriodeProsesTagih1(getFirstDayOfMonthYmd());
                if (!periodeProsesTagih2) setPeriodeProsesTagih2(today);
                setShowModalProsesTagih(true);
              }}
              style={vbBtnStyle}
              title="Laporan Proses Tagih Piutang (BPJS & Non-BPJS)"
            >
              <i className="bi bi-file-earmark-text-fill text-primary fs-6"></i>
              <span><u>L</u>APORAN PROSES TAGIH</span>
            </button>
          </div>

          {/* 5. BERSIH */}
          <div>
            <button
              type="button"
              disabled={isLoading || isProcessing}
              onClick={handleBersih}
              style={vbBtnBersihStyle}
              title="Bersihkan Form & Data Tabel"
            >
              <i className="bi bi-x-circle-fill text-danger fs-6"></i>
              <span>BER<u>S</u>IH</span>
            </button>
          </div>
        </div>

        {errorMsg && (
          <div className="alert alert-danger py-2 px-3 mb-2 rounded-3 d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
            <i className="bi bi-exclamation-triangle-fill text-danger fs-6"></i>
            <span>{errorMsg}</span>
          </div>
        )}

        {/* Data Table */}
        <Card className="shadow-sm border-0 rounded-3 overflow-hidden bg-white">
          <Card.Header className="bg-white py-2 px-3 border-bottom d-flex align-items-center justify-content-between" style={{ minHeight: 'auto' }}>
            <span className="fw-bold text-dark d-flex align-items-center gap-2" style={{ fontSize: '0.82rem' }}>
              <i className="bi bi-table text-primary"></i> Rincian Buku Piutang & Transaksi
            </span>
            <span className="text-muted" style={{ fontSize: '0.72rem' }}>
              Menampilkan <strong>{dataPiutang.length}</strong> baris data
            </span>
          </Card.Header>
          <Card.Body className="p-0">
            <div className="table-responsive" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
              <Table hover striped className="mb-0 align-middle" style={{ fontSize: '0.78rem' }}>
                <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <tr className="text-center text-nowrap">
                    <th className="py-2 px-2" style={{ background: '#1e293b', color: '#f8fafc', border: '1px solid #334155', width: '90px' }}>TGL TAGIH</th>
                    <th className="py-2 px-2" style={{ background: '#1e293b', color: '#f8fafc', border: '1px solid #334155' }}>NO KUITANSI</th>
                    <th className="py-2 px-2" style={{ background: '#1e293b', color: '#f8fafc', border: '1px solid #334155' }}>NO PELUNASAN</th>
                    <th className="py-2 px-2" style={{ background: '#1e293b', color: '#f8fafc', border: '1px solid #334155', width: '90px' }}>TGL LUNAS</th>
                    <th className="py-2 px-2 text-end" style={{ background: '#1e293b', color: '#f8fafc', border: '1px solid #334155' }}>TOTAL TAGIHAN</th>
                    <th className="py-2 px-2 text-end" style={{ background: '#1e293b', color: '#f8fafc', border: '1px solid #334155' }}>PEMBAYARAN</th>
                    <th className="py-2 px-2 text-end" style={{ background: '#1e293b', color: '#f8fafc', border: '1px solid #334155' }}>SISA / SALDO</th>
                    <th className="py-2 px-2" style={{ background: '#1e293b', color: '#f8fafc', border: '1px solid #334155' }}>KD BANK</th>
                  </tr>
                </thead>
                <tbody>
                  {dataPiutang.length > 0 ? (
                    dataPiutang.map((item, index) => {
                      const isLunas = Number(item.saldo || item.sisa || 0) <= 0;
                      return (
                        <tr key={index} className={item.proses === 'X' ? 'table-warning' : ''}>
                          <td className="text-center font-monospace">{item.tgl_tagih || '-'}</td>
                          <td className="text-center fw-bold text-primary font-monospace">{item.no_kuitansi}</td>
                          <td className="text-center font-monospace">{item.no_pelunasan || '-'}</td>
                          <td className="text-center font-monospace">{item.tgl_lunas || '-'}</td>
                          <td className="text-end fw-bold text-dark">{formatRp(item.total)}</td>
                          <td className="text-end text-success fw-bold">{formatRp(item.pembayaran)}</td>
                          <td className="text-end fw-bold">
                            <span className={isLunas ? 'text-success' : 'text-danger'}>
                              {formatRp(item.saldo || item.sisa)}
                            </span>
                          </td>
                          <td className="text-center">
                            {item.kd_bank ? (
                              <Badge bg="light" text="dark" className="border">
                                {item.kd_bank}
                              </Badge>
                            ) : '-'}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center text-muted py-5">
                        {isLoading ? (
                          <div className="d-flex flex-column align-items-center gap-2">
                            <Spinner animation="border" variant="primary" />
                            <span className="fw-medium">Memuat data piutang...</span>
                          </div>
                        ) : (
                          <div>
                            <i className="bi bi-inbox fs-1 d-block mb-2 text-secondary opacity-50"></i>
                            <span className="fw-medium">Belum ada data piutang yang ditampilkan.</span>
                            <span className="d-block text-muted" style={{ fontSize: '0.75rem' }}>
                              Silakan pilih debitor dan tekan tombol <strong>Tampilkan</strong> di atas.
                            </span>
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card.Body>
          {dataPiutang.length > 0 && (
            <Card.Footer className="bg-white py-2 px-3 border-top d-flex justify-content-between align-items-center" style={{ fontSize: '0.75rem', borderTop: '2px solid #e2e8f0' }}>
              <span className="text-muted">Total: <strong>{dataPiutang.length}</strong> transaksi</span>
              <div className="d-flex gap-3">
                <span>Tagihan: <strong className="text-primary">{formatRp(summary.totTagihan)}</strong></span>
                <span>Terbayar: <strong className="text-success">{formatRp(summary.totBayar)}</strong></span>
                <span>Sisa Saldo: <strong className="text-danger">{formatRp(summary.totSisa)}</strong></span>
              </div>
            </Card.Footer>
          )}
        </Card>
      </Container>
    
      {/* ========================================================================= */}
      {/* 📄 MODAL PARAMETER CETAK LAPORAN (Modern & Professional UI)               */}
      {/* ========================================================================= */}
      <Modal 
        show={showLaporanModal} 
        onHide={() => setShowLaporanModal(false)} 
        centered 
        size="lg" 
        backdrop="static"
        dialogClassName="modal-modern"
      >
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: '#fff', borderBottom: '2px solid #3b82f6' }} className="py-3 px-4">
          <Modal.Title style={{ fontSize: '1rem', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="bi bi-printer-fill text-warning"></i>
            Cetak & View Laporan Kartu / Buku Piutang
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body className="p-4 bg-light">
          <Card className="border-0 shadow-sm rounded-3 bg-white p-3 mb-3">
            <Form>
              {/* 1. Jenis Laporan */}
              <div className="mb-3">
                <Form.Label className="fw-bold text-dark d-flex align-items-center gap-2 mb-2" style={{ fontSize: '0.85rem' }}>
                  <i className="bi bi-file-earmark-bar-graph text-primary"></i> 1. Jenis Laporan
                </Form.Label>
                <Row className="g-2">
                  <Col md={6}>
                    <div 
                      className={`p-3 rounded-3 border d-flex align-items-center gap-3 cursor-pointer ${laporanJenis === 'buku' ? 'border-primary bg-primary bg-opacity-10 text-primary' : 'bg-white text-secondary'}`}
                      style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                      onClick={() => setLaporanJenis('buku')}
                    >
                      <Form.Check 
                        type="radio" 
                        id="jns-buku" 
                        name="jns_laporan" 
                        checked={laporanJenis === 'buku'} 
                        onChange={() => setLaporanJenis('buku')} 
                      />
                      <div>
                        <strong className="d-block text-dark" style={{ fontSize: '0.85rem' }}>Laporan Buku Piutang</strong>
                        <span className="text-muted" style={{ fontSize: '0.72rem' }}>Rekapitulasi total mutasi saldo seluruh debitor</span>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div 
                      className={`p-3 rounded-3 border d-flex align-items-center gap-3 cursor-pointer ${laporanJenis === 'kartu' ? 'border-primary bg-primary bg-opacity-10 text-primary' : 'bg-white text-secondary'}`}
                      style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                      onClick={() => setLaporanJenis('kartu')}
                    >
                      <Form.Check 
                        type="radio" 
                        id="jns-kartu" 
                        name="jns_laporan" 
                        checked={laporanJenis === 'kartu'} 
                        onChange={() => setLaporanJenis('kartu')} 
                      />
                      <div>
                        <strong className="d-block text-dark" style={{ fontSize: '0.85rem' }}>Laporan Kartu Piutang</strong>
                        <span className="text-muted" style={{ fontSize: '0.72rem' }}>Rincian debit/kredit per nomor invoice debitor</span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* 2. Jenis Piutang */}
              <div className="mb-3">
                <Form.Label className="fw-bold text-dark d-flex align-items-center gap-2 mb-2" style={{ fontSize: '0.85rem' }}>
                  <i className="bi bi-tag text-primary"></i> 2. Kategori Debitor / Jenis Piutang
                </Form.Label>
                <Form.Select 
                  value={laporanJenisPiutang} 
                  onChange={e => setLaporanJenisPiutang(e.target.value)}
                  className="rounded-2 py-2"
                  style={{ fontSize: '0.85rem' }}
                >
                  <option value="1">1 — Perusahaan Rekanan & Asuransi</option>
                  <option value="2">2 — Karyawan | Dokter</option>
                  <option value="3">3 — Pribadi / Pasien Umum</option>
                </Form.Select>
              </div>

              {/* 3. Debitor Selection */}
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <Form.Label className="fw-bold text-dark d-flex align-items-center gap-2 mb-0" style={{ fontSize: '0.85rem' }}>
                    <i className="bi bi-building text-primary"></i> 3. Debitor
                  </Form.Label>
                  <Form.Check 
                    type="switch"
                    id="switch-semua-debitor"
                    label={<span className="fw-semibold text-primary" style={{ fontSize: '0.8rem' }}>Semua Debitor</span>}
                    checked={laporanDebitorSemua}
                    onChange={e => setLaporanDebitorSemua(e.target.checked)}
                  />
                </div>
                
                {!laporanDebitorSemua && (
                  <Row className="g-2">
                    <Col md={4}>
                      <Form.Control 
                        size="sm" 
                        type="text" 
                        placeholder="Kode Debitor" 
                        value={laporanDebitorKode} 
                        onChange={e => setLaporanDebitorKode(e.target.value)}
                        style={{ fontSize: '0.82rem' }}
                      />
                    </Col>
                    <Col md={8}>
                      <Form.Control 
                        size="sm" 
                        type="text" 
                        placeholder="Nama Debitor / Perusahaan" 
                        value={laporanDebitorNama} 
                        onChange={e => setLaporanDebitorNama(e.target.value)}
                        style={{ fontSize: '0.82rem' }}
                      />
                    </Col>
                  </Row>
                )}
              </div>

              {/* 4. Periode Tanggal */}
              <div>
                <Form.Label className="fw-bold text-dark d-flex align-items-center gap-2 mb-2" style={{ fontSize: '0.85rem' }}>
                  <i className="bi bi-calendar-range text-primary"></i> 4. Periode Tanggal Laporan
                </Form.Label>
                <Row className="g-2 align-items-center">
                  <Col md={5}>
                    <InputGroup size="sm">
                      <InputGroup.Text className="bg-light text-muted"><i className="bi bi-calendar-event"></i></InputGroup.Text>
                      <Form.Control 
                        type="date" 
                        value={laporanPeriode1} 
                        onChange={e => setLaporanPeriode1(e.target.value)}
                        style={{ fontSize: '0.82rem' }}
                      />
                    </InputGroup>
                  </Col>
                  <Col md={2} className="text-center">
                    <Badge bg="secondary" className="px-3 py-2 fw-semibold">S/D</Badge>
                  </Col>
                  <Col md={5}>
                    <InputGroup size="sm">
                      <InputGroup.Text className="bg-light text-muted"><i className="bi bi-calendar-event"></i></InputGroup.Text>
                      <Form.Control 
                        type="date" 
                        value={laporanPeriode2} 
                        onChange={e => setLaporanPeriode2(e.target.value)}
                        style={{ fontSize: '0.82rem' }}
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </div>
            </Form>
          </Card>
        </Modal.Body>
        
        <Modal.Footer className="bg-white border-top py-3 px-4 d-flex justify-content-between">
          <Button 
            variant="outline-secondary" 
            size="sm" 
            className="px-3 py-2 rounded-2 fw-semibold"
            onClick={() => setShowLaporanModal(false)}
          >
            <i className="bi bi-x-circle me-1"></i> Batal
          </Button>
          <Button 
            variant="primary" 
            size="sm" 
            className="px-4 py-2 rounded-2 fw-bold d-flex align-items-center gap-2 shadow-sm"
            onClick={handleCetakBukuPiutang}
          >
            <i className="bi bi-eye-fill"></i> Proses & Tampilkan Laporan
          </Button>
        </Modal.Footer>
      </Modal>


      {/* ========================================================================= */}
      {/* ⏳ MODAL PROGRESS PROSES LAPORAN                                          */}
      {/* ========================================================================= */}
      <Modal show={showProgressModal} centered backdrop="static" keyboard={false} size="sm">
        <div className="bg-white rounded-3 p-4 shadow-lg text-center border">
          <div className="mb-3">
            <div className="spinner-grow text-primary mb-2" role="status" style={{ width: '2.5rem', height: '2.5rem' }}></div>
            <h6 className="fw-bold text-dark mb-1">Memproses Laporan</h6>
            <span className="text-muted" style={{ fontSize: '0.75rem' }}>{progressStatusText}</span>
          </div>
          <ProgressBar 
            animated 
            now={progressPercent} 
            label={`${progressPercent}%`} 
            variant="primary" 
            className="rounded-pill shadow-none"
            style={{ height: '16px', fontSize: '0.75rem' }}
          />
        </div>
      </Modal>


      {/* ========================================================================= */}
      {/* 🖼️ MODAL IN-APP PDF VIEWER (View Langsung dari Aplikasi Tanpa Tab Baru)     */}
      {/* ========================================================================= */}
      <Modal 
        show={showModalPdf} 
        onHide={() => { setShowModalPdf(false); setPdfUrl(''); }} 
        size={isPdfFullscreen ? undefined : "xl"}
        fullscreen={isPdfFullscreen}
        centered 
        backdrop="static"
        className="modal-pdf-viewer"
      >
        <Modal.Header className="py-2 px-4 d-flex justify-content-between align-items-center" style={{ background: '#0f172a', color: '#fff', borderBottom: '2px solid #3b82f6' }}>
          <div className="d-flex align-items-center gap-2 text-truncate" style={{ maxWidth: '60%' }}>
            <div className="p-1 rounded bg-danger text-white d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-file-earmark-pdf-fill fs-6"></i>
            </div>
            <div>
              <span className="fw-bold d-block text-truncate" style={{ fontSize: '0.9rem' }}>{pdfTitle}</span>
              <span className="text-light text-opacity-75" style={{ fontSize: '0.7rem' }}>Pratinjau Dokumen Resmi SIMRS</span>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            {/* Download Button */}
            {pdfUrl && (
              <a 
                href={pdfUrl} 
                download 
                className="btn btn-sm btn-outline-light d-flex align-items-center gap-1 py-1 px-2"
                style={{ fontSize: '0.75rem' }}
                title="Unduh File PDF"
              >
                <i className="bi bi-download"></i> Unduh
              </a>
            )}

            {/* Print Button */}
            <Button
              variant="outline-warning"
              size="sm"
              className="d-flex align-items-center gap-1 py-1 px-2 text-white"
              style={{ fontSize: '0.75rem' }}
              onClick={handlePrintIframe}
              title="Cetak Dokumen"
            >
              <i className="bi bi-printer-fill text-warning"></i> Cetak
            </Button>

            {/* Fullscreen Toggle */}
            <Button
              variant="outline-light"
              size="sm"
              className="py-1 px-2"
              style={{ fontSize: '0.75rem' }}
              onClick={() => setIsPdfFullscreen(!isPdfFullscreen)}
              title={isPdfFullscreen ? "Keluar Layar Penuh" : "Layar Penuh"}
            >
              <i className={`bi ${isPdfFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'}`}></i>
            </Button>

            {/* Close Button */}
            <Button
              variant="danger"
              size="sm"
              className="py-1 px-2 fw-bold"
              style={{ fontSize: '0.75rem' }}
              onClick={() => { setShowModalPdf(false); setPdfUrl(''); }}
              title="Tutup Preview"
            >
              <i className="bi bi-x-lg"></i>
            </Button>
          </div>
        </Modal.Header>

        <Modal.Body className="p-0 bg-secondary bg-opacity-25" style={{ height: isPdfFullscreen ? 'calc(100vh - 60px)' : '80vh' }}>
          {pdfUrl ? (
            <iframe 
              ref={iframeRef}
              src={pdfUrl} 
              title={pdfTitle} 
              width="100%" 
              height="100%" 
              style={{ border: 'none', display: 'block' }} 
            />
          ) : (
            <div className="d-flex flex-column h-100 justify-content-center align-items-center text-muted gap-2">
              <Spinner animation="border" variant="primary" />
              <span className="fw-semibold">Memuat dokumen PDF di dalam aplikasi...</span>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ========================================================================= */}
      {/* 💳 MODAL SALDO PENERIMAAN PELUNASAN PIUTANG (Sesuai Gambar Dialog VB)      */}
      {/* ========================================================================= */}
      <Modal 
        show={showModalAngsuran} 
        onHide={() => setShowModalAngsuran(false)} 
        size="lg" 
        centered 
        backdrop="static"
      >
        <div style={{ backgroundColor: '#e2e8f0', borderRadius: '4px', overflow: 'hidden', border: '1px solid #64748b', boxShadow: '0 10px 25px rgba(0,0,0,0.3)' }}>
          {/* Header Title Bar */}
          <div style={{ 
            background: '#002f3d', 
            color: '#ffffff', 
            textAlign: 'center', 
            padding: '6px 12px', 
            fontWeight: 'bold', 
            fontSize: '13px',
            letterSpacing: '0.5px',
            borderBottom: '2px solid #f59e0b'
          }}>
            SALDO PENERIMAAN PELUNASAN PIUTANG
          </div>

          {/* Table Container */}
          <div style={{ padding: '8px', backgroundColor: '#e2e8f0' }}>
            <div style={{ 
              backgroundColor: '#ffffff', 
              border: '1px solid #94a3b8', 
              minHeight: '220px', 
              maxHeight: '320px', 
              overflowY: 'auto',
              overflowX: 'auto'
            }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
                <thead>
                  <tr style={{ background: '#008080', color: '#ffffff', textAlign: 'center', fontWeight: 'bold' }}>
                    <th style={{ border: '1px solid #005959', padding: '6px 8px', whiteSpace: 'nowrap' }}>NOMOR PELUNASAN</th>
                    <th style={{ border: '1px solid #005959', padding: '6px 8px', whiteSpace: 'nowrap' }}>TANGGAL BANK</th>
                    <th style={{ border: '1px solid #005959', padding: '6px 8px', whiteSpace: 'nowrap' }}>NOMOR REKENING</th>
                    <th style={{ border: '1px solid #005959', padding: '6px 8px', whiteSpace: 'nowrap' }}>BANK</th>
                    <th style={{ border: '1px solid #005959', padding: '6px 8px', whiteSpace: 'nowrap', textAlign: 'right' }}>NILAI [Rp]</th>
                  </tr>
                </thead>
                <tbody>
                  {isAngsuranLoading ? (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '40px 10px', color: '#64748b' }}>
                        <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                        <strong>Memuat data saldo penerimaan pelunasan...</strong>
                      </td>
                    </tr>
                  ) : listAngsuran.length > 0 ? (
                    listAngsuran.map((item, idx) => (
                      <tr key={idx} style={{ backgroundColor: idx % 2 === 1 ? '#f8fafc' : '#ffffff', borderBottom: '1px solid #e2e8f0' }}>
                        <td style={{ border: '1px solid #cbd5e1', padding: '5px 8px', fontWeight: 'bold', color: '#0f172a' }}>
                          {item.no_pelunasan || '-'}
                        </td>
                        <td style={{ border: '1px solid #cbd5e1', padding: '5px 8px', textAlign: 'center', fontWeight: 'bold', color: '#1e293b' }}>
                          {item.tgl_bank || '-'}
                        </td>
                        <td style={{ border: '1px solid #cbd5e1', padding: '5px 8px', fontWeight: 'bold', color: '#0f172a' }}>
                          {item.no_rekening || '-'}
                        </td>
                        <td style={{ border: '1px solid #cbd5e1', padding: '5px 8px', fontWeight: 'bold', color: '#1e293b' }}>
                          {item.nm_bank || '-'}
                        </td>
                        <td style={{ border: '1px solid #cbd5e1', padding: '5px 8px', textAlign: 'right', fontWeight: 'bold', color: '#0f172a' }}>
                          {formatAngka(item.pembayaran)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '40px 10px', color: '#64748b', fontWeight: '600' }}>
                        Tidak ada data penerimaan saldo pelunasan untuk debitor ini.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Saldo Summary Box */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '6px', alignItems: 'center' }}>
              <div style={{
                background: '#004785',
                color: '#ffffff',
                fontWeight: 'bold',
                fontSize: '12px',
                padding: '4px 18px',
                border: '1px solid #002d5a',
                borderRight: 'none',
                letterSpacing: '0.5px'
              }}>
                SALDO [Rp]
              </div>
              <div style={{
                background: '#1e293b',
                color: '#4ade80',
                fontWeight: 'bold',
                fontFamily: 'monospace',
                fontSize: '13px',
                padding: '4px 18px',
                border: '1px solid #0f172a',
                minWidth: '130px',
                textAlign: 'right'
              }}>
                {formatAngka(totalAngsuran)}
              </div>
            </div>

            {/* Bottom Button Bar */}
            <div style={{ 
              display: 'flex', 
              flexWrap: 'wrap', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              marginTop: '10px',
              paddingTop: '6px'
            }}>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {/* PELUNASAN MANUAL */}
                <button
                  type="button"
                  onClick={() => {
                    showMsg(`Fitur Pelunasan Manual untuk debitor [${kdprs}] ${nama || ''}.`, 'info', 'Pelunasan Manual');
                  }}
                  style={vbBtnStyle}
                  title="Pelunasan Manual"
                >
                  <span className="d-inline-flex align-items-center justify-content-center p-1 rounded bg-white border" style={{ borderColor: '#94a3b8', lineHeight: 1 }}>
                    <i className="bi bi-window-sidebar" style={{ color: '#0284c7', fontSize: '0.85rem' }}></i>
                  </span>
                  <span>PELUNASAN <u>M</u>ANUAL</span>
                </button>

                {/* PELUNASAN AUTOMATIC */}
                <button
                  type="button"
                  onClick={() => {
                    setShowModalAngsuran(false);
                    handleProsesPelunasan();
                  }}
                  style={vbBtnStyle}
                  title="Pelunasan Automatic"
                >
                  <span className="d-inline-flex align-items-center justify-content-center p-1 rounded bg-white border" style={{ borderColor: '#94a3b8', lineHeight: 1 }}>
                    <i className="bi bi-window-split" style={{ color: '#2563eb', fontSize: '0.85rem' }}></i>
                  </span>
                  <span><u>P</u>ELUNASAN AUTOMATIC</span>
                </button>

                {/* CETAK SALDO */}
                <button
                  type="button"
                  onClick={handleCetakSaldo}
                  style={vbBtnStyle}
                  title="Cetak Saldo Penerimaan Pelunasan"
                >
                  <i className="bi bi-printer text-dark fs-6"></i>
                  <span><u>C</u>ETAK SALDO</span>
                </button>
              </div>

              <div>
                {/* TUTUP */}
                <button
                  type="button"
                  onClick={() => setShowModalAngsuran(false)}
                  style={vbBtnBersihStyle}
                  title="Tutup Jendela"
                >
                  <i className="bi bi-x-circle-fill text-danger fs-6"></i>
                  <span>TUTUP</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* ========================================================================= */}
      {/* 📄 MODAL RINCIAN PELUNASAN / SUMMARY PELUNASAN (Sesuai Gambar VB)         */}
      {/* ========================================================================= */}
      <Modal 
        show={showModalSummary} 
        onHide={() => setShowModalSummary(false)} 
        centered 
        backdrop="static"
        dialogClassName="modal-rincian-pelunasan"
      >
        <style>{`
          .modal-rincian-pelunasan {
            max-width: 660px !important;
          }
          .modal-rincian-pelunasan .modal-content {
            border: none !important;
            background: transparent !important;
            box-shadow: none !important;
          }
          .modal-rincian-pelunasan .react-datepicker {
            width: 100% !important;
            border: 1px solid #708090 !important;
            border-radius: 3px !important;
            font-family: inherit !important;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
            background: #ffffff !important;
          }
          .modal-rincian-pelunasan .react-datepicker__month-container {
            width: 100% !important;
          }
          .modal-rincian-pelunasan .react-datepicker__header {
            background: #002f3d !important;
            border-bottom: 2px solid #f59e0b !important;
            padding: 6px 0 0 0 !important;
          }
          .modal-rincian-pelunasan .react-datepicker__current-month {
            color: #ffffff !important;
            font-weight: 700 !important;
            font-size: 0.85rem !important;
            margin-bottom: 4px !important;
          }
          .modal-rincian-pelunasan .react-datepicker__day-names {
            background: #4a709c !important;
            margin: 4px 0 0 0 !important;
            display: flex !important;
            justify-content: space-around !important;
          }
          .modal-rincian-pelunasan .react-datepicker__day-name {
            color: #ffffff !important;
            font-weight: 700 !important;
            font-size: 0.72rem !important;
            width: 2rem !important;
            line-height: 1.5rem !important;
            margin: 0 !important;
          }
          .modal-rincian-pelunasan .react-datepicker__month {
            margin: 4px !important;
          }
          .modal-rincian-pelunasan .react-datepicker__week {
            display: flex !important;
            justify-content: space-around !important;
          }
          .modal-rincian-pelunasan .react-datepicker__day {
            width: 2rem !important;
            line-height: 1.8rem !important;
            font-size: 0.78rem !important;
            margin: 1px 0 !important;
            border-radius: 3px !important;
          }
          .modal-rincian-pelunasan .react-datepicker__day--in-range,
          .modal-rincian-pelunasan .react-datepicker__day--in-selecting-range {
            background-color: #bae6fd !important;
            color: #0369a1 !important;
            font-weight: 600 !important;
          }
          .modal-rincian-pelunasan .react-datepicker__day--range-start,
          .modal-rincian-pelunasan .react-datepicker__day--range-end,
          .modal-rincian-pelunasan .react-datepicker__day--selected {
            background-color: #004785 !important;
            color: #ffffff !important;
            font-weight: 700 !important;
          }
          .modal-rincian-pelunasan .react-datepicker__navigation-icon::before {
            border-color: #ffffff !important;
          }
        `}</style>
        <div style={{ width: '100%', backgroundColor: '#cbd5e1', borderRadius: '4px', overflow: 'hidden', border: '1px solid #64748b', boxShadow: '0 10px 25px rgba(0,0,0,0.3)' }}>
          {/* Header Title Bar */}
          <div style={{ 
            background: '#002f3d', 
            color: '#ffffff', 
            textAlign: 'center', 
            padding: '6px 12px', 
            fontWeight: 'bold', 
            fontSize: '13px',
            letterSpacing: '0.5px',
            borderBottom: '2px solid #f59e0b'
          }}>
            RINCIAN PELUNASAN
          </div>

          {/* Dialog Body */}
          <div style={{ padding: '10px', backgroundColor: '#cbd5e1' }}>
            <Row className="g-2 align-items-center">
              {/* Left Column: Form Inputs & Action Buttons */}
              <Col md={6}>
                {/* 1. PERIODE PELUNASAN */}
                <div className="mb-2">
                  <InputGroup size="sm" style={{ border: '1px solid #708090', borderRadius: '3px', overflow: 'hidden' }}>
                    <InputGroup.Text style={{ background: '#004785', color: '#ffffff', fontWeight: 'bold', fontSize: '10px', minWidth: '130px', justifyContent: 'center', border: 'none', borderRadius: 0, letterSpacing: '0.3px' }}>
                      PERIODE PELUNASAN
                    </InputGroup.Text>
                    <Form.Control
                      type="date"
                      value={periodeSummary1}
                      onChange={(e) => setPeriodeSummary1(e.target.value)}
                      style={{ fontWeight: 'bold', fontSize: '11px', border: 'none', borderRadius: 0, textAlign: 'center', background: '#ffffff' }}
                    />
                  </InputGroup>
                </div>

                {/* 2. SAMPAI DENGAN */}
                <div className="mb-2">
                  <InputGroup size="sm" style={{ border: '1px solid #708090', borderRadius: '3px', overflow: 'hidden' }}>
                    <InputGroup.Text style={{ background: '#004785', color: '#ffffff', fontWeight: 'bold', fontSize: '10px', minWidth: '130px', justifyContent: 'center', border: 'none', borderRadius: 0, letterSpacing: '0.3px' }}>
                      SAMPAI DENGAN
                    </InputGroup.Text>
                    <Form.Control
                      type="date"
                      value={periodeSummary2}
                      onChange={(e) => setPeriodeSummary2(e.target.value)}
                      style={{ fontWeight: 'bold', fontSize: '11px', border: 'none', borderRadius: 0, textAlign: 'center', background: '#ffffff' }}
                    />
                  </InputGroup>
                </div>

                {/* Status / Info Box */}
                <div style={{ 
                  background: '#ffffff', 
                  border: '1px solid #94a3b8', 
                  borderRadius: '2px', 
                  padding: '6px 8px', 
                  minHeight: '62px', 
                  fontSize: '11px', 
                  color: '#334155',
                  marginBottom: '10px'
                }}>
                  <div className="fw-bold text-dark text-truncate">
                    <i className="bi bi-building me-1 text-primary"></i> 
                    {kdprs ? `[${kdprs}] ${nama || ''}` : 'Semua Debitor / Rekanan'}
                  </div>
                  <div className="text-muted mt-1" style={{ fontSize: '10px' }}>
                    Pilih tanggal menggunakan input di atas atau klik langsung rentang tanggal pada kalender.
                  </div>
                </div>

                {/* Bottom Action Buttons */}
                <div className="d-flex gap-2">
                  {/* PROSES */}
                  <button
                    type="button"
                    disabled={isLoading || isProcessing}
                    onClick={handleProsesCetakSummary}
                    style={vbBtnStyle}
                    title="Proses Cetak Dokumen Summary Pelunasan"
                  >
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-1">
                      <circle cx="12" cy="3" r="2" fill="#2563eb" opacity="0.35"/>
                      <circle cx="18.36" cy="5.64" r="2.2" fill="#2563eb" opacity="0.5"/>
                      <circle cx="21" cy="12" r="2.4" fill="#2563eb" opacity="0.65"/>
                      <circle cx="18.36" cy="18.36" r="2.6" fill="#2563eb" opacity="0.8"/>
                      <circle cx="12" cy="21" r="2.8" fill="#1d4ed8"/>
                      <circle cx="5.64" cy="18.36" r="2.6" fill="#2563eb" opacity="0.8"/>
                      <circle cx="3" cy="12" r="2.2" fill="#2563eb" opacity="0.5"/>
                      <circle cx="5.64" cy="5.64" r="2" fill="#2563eb" opacity="0.35"/>
                    </svg>
                    <span><u>P</u>ROSES</span>
                  </button>

                  {/* TUTUP */}
                  <button
                    type="button"
                    onClick={() => setShowModalSummary(false)}
                    style={vbBtnBersihStyle}
                    title="Tutup Jendela"
                  >
                    <i className="bi bi-x-circle-fill text-danger fs-6"></i>
                    <span><u>T</u>UTUP</span>
                  </button>
                </div>
              </Col>

              {/* Right Column: React-DatePicker Interactive Calendar */}
              <Col md={6} className="d-flex justify-content-center">
                <div style={{ width: '100%', maxWidth: '270px' }}>
                  <DatePicker
                    inline
                    selectsRange
                    startDate={periodeSummary1 ? new Date(periodeSummary1 + 'T00:00:00') : null}
                    endDate={periodeSummary2 ? new Date(periodeSummary2 + 'T00:00:00') : null}
                    onChange={(dates) => {
                      const [start, end] = dates;
                      if (start) {
                        const y = start.getFullYear();
                        const m = String(start.getMonth() + 1).padStart(2, '0');
                        const d = String(start.getDate()).padStart(2, '0');
                        setPeriodeSummary1(`${y}-${m}-${d}`);
                      }
                      if (end) {
                        const y = end.getFullYear();
                        const m = String(end.getMonth() + 1).padStart(2, '0');
                        const d = String(end.getDate()).padStart(2, '0');
                        setPeriodeSummary2(`${y}-${m}-${d}`);
                      }
                    }}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Modal>

      {/* ========================================================================= */}
      {/* 📑 MODAL LAPORAN PROSES TAGIH PIUTANG (Sesuai Referensi Gambar VB)        */}
      {/* ========================================================================= */}
      <Modal 
        show={showModalProsesTagih} 
        onHide={() => !isProsesTagihLoading && setShowModalProsesTagih(false)} 
        centered 
        backdrop="static"
        dialogClassName="modal-proses-tagih-piutang"
      >
        <style>{`
          .modal-proses-tagih-piutang {
            max-width: 580px !important;
          }
          .modal-proses-tagih-piutang .modal-content {
            border: none !important;
            background: transparent !important;
            box-shadow: none !important;
          }
        `}</style>
        <div style={{ width: '100%', backgroundColor: '#cbd5e1', borderRadius: '6px', overflow: 'hidden', border: '1px solid #475569', boxShadow: '0 12px 32px rgba(0,0,0,0.35)' }}>
          {/* Header Title Bar Sesuai Gambar */}
          <div style={{ 
            background: 'linear-gradient(180deg, #002f3d 0%, #001f29 100%)', 
            color: '#ffffff', 
            textAlign: 'center', 
            padding: '9px 16px', 
            fontWeight: 'bold', 
            fontSize: '14px',
            letterSpacing: '0.6px',
            borderBottom: '2px solid #0284c7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}>
            <i className="bi bi-file-earmark-text-fill text-warning"></i>
            <span>LAPORAN PROSES TAGIH PIUTANG</span>
          </div>

          {/* Dialog Body */}
          <div style={{ padding: '16px', backgroundColor: '#cbd5e1' }}>
            {/* 1. PERIODE */}
            <div className="mb-2">
              <InputGroup size="sm" style={{ border: '1px solid #708090', borderRadius: '4px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
                <InputGroup.Text style={{ 
                  background: '#004785', 
                  color: '#ffffff', 
                  fontWeight: 'bold', 
                  fontSize: '11px', 
                  minWidth: '110px', 
                  justifyContent: 'center', 
                  border: 'none', 
                  borderRadius: 0, 
                  letterSpacing: '0.4px' 
                }}>
                  PERIODE
                </InputGroup.Text>
                <Form.Control
                  type="date"
                  value={periodeProsesTagih1}
                  onChange={(e) => setPeriodeProsesTagih1(e.target.value)}
                  disabled={isProsesTagihLoading}
                  style={{ 
                    borderRadius: 0, 
                    fontSize: '11px', 
                    fontWeight: 'bold', 
                    backgroundColor: '#ffffcc', 
                    border: 'none', 
                    color: '#0f172a' 
                  }}
                />
              </InputGroup>
            </div>

            {/* 2. S.D */}
            <div className="mb-3">
              <InputGroup size="sm" style={{ border: '1px solid #708090', borderRadius: '4px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
                <InputGroup.Text style={{ 
                  background: '#004785', 
                  color: '#ffffff', 
                  fontWeight: 'bold', 
                  fontSize: '11px', 
                  minWidth: '110px', 
                  justifyContent: 'center', 
                  border: 'none', 
                  borderRadius: 0, 
                  letterSpacing: '0.4px' 
                }}>
                  S.D
                </InputGroup.Text>
                <Form.Control
                  type="date"
                  value={periodeProsesTagih2}
                  onChange={(e) => setPeriodeProsesTagih2(e.target.value)}
                  disabled={isProsesTagihLoading}
                  style={{ 
                    borderRadius: 0, 
                    fontSize: '11px', 
                    fontWeight: 'bold', 
                    backgroundColor: '#ffffff', 
                    border: 'none', 
                    color: '#0f172a' 
                  }}
                />
              </InputGroup>
            </div>

            {/* Info badge */}
            <div className="alert alert-info py-2 px-3 mb-3 d-flex align-items-center gap-2 rounded-2" style={{ fontSize: '0.75rem', backgroundColor: '#e0f2fe', borderColor: '#bae6fd', color: '#0369a1' }}>
              <i className="bi bi-info-circle-fill fs-6 flex-shrink-0"></i>
              <span>Otomatis menyusun <strong>2 berkas laporan</strong> resmi: Tagihan <strong>Non-BPJS</strong> &amp; Tagihan <strong>BPJS</strong>.</span>
            </div>

            {/* Progress Bar & Status saat loading */}
            {isProsesTagihLoading && (
              <div className="p-3 mb-3 rounded-2 bg-white border shadow-sm">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <span className="fw-semibold text-primary" style={{ fontSize: '0.75rem' }}>
                    <Spinner animation="border" size="sm" className="me-2" />
                    {prosesTagihStatusText || 'Sedang memproses...'}
                  </span>
                  <span className="fw-bold text-muted" style={{ fontSize: '0.75rem' }}>{prosesTagihProgress}%</span>
                </div>
                <ProgressBar animated now={prosesTagihProgress} variant="primary" style={{ height: '8px' }} />
              </div>
            )}

            {/* Result Cards Jika Selesai */}
            {prosesTagihResult && !isProsesTagihLoading && (
              <div className="p-3 mb-3 rounded-3 bg-white border shadow-sm">
                <h6 className="fw-bold text-dark mb-2 d-flex align-items-center gap-2" style={{ fontSize: '0.82rem' }}>
                  <i className="bi bi-check-circle-fill text-success"></i>
                  Hasil Pemrosesan 2 Laporan Tagihan:
                </h6>

                {/* Card Non-BPJS */}
                <div className="p-2 mb-2 rounded-2 border" style={{ background: '#f8fafc', borderColor: '#e2e8f0' }}>
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div>
                      <span className="fw-bold text-primary d-block" style={{ fontSize: '0.8rem' }}>
                        1. Laporan Tagihan Non-BPJS
                      </span>
                      <span className="text-muted" style={{ fontSize: '0.72rem' }}>
                        {prosesTagihResult.non_bpjs?.count_kuitansi || 0} Kuitansi &bull; {prosesTagihResult.non_bpjs?.count_transaksi || 0} Transaksi &bull; 
                        <strong className="text-dark ms-1">Rp {(prosesTagihResult.non_bpjs?.total_nominal || 0).toLocaleString('id-ID')}</strong>
                      </span>
                    </div>
                    <div className="d-flex gap-1">
                      <Button
                        variant="primary"
                        size="sm"
                        className="d-flex align-items-center gap-1 py-1 px-2 fw-semibold"
                        style={{ fontSize: '0.72rem' }}
                        onClick={() => handlePreviewPdfTagih('non_bpjs')}
                      >
                        <i className="bi bi-file-earmark-pdf-fill"></i> Lihat PDF
                      </Button>
                      <Button
                        variant="success"
                        size="sm"
                        className="d-flex align-items-center gap-1 py-1 px-2 fw-semibold"
                        style={{ fontSize: '0.72rem' }}
                        onClick={() => handleDownloadExcelTagih('non_bpjs')}
                      >
                        <i className="bi bi-file-earmark-excel-fill"></i> Excel
                      </Button>
                    </div>
                  </div>
                </div>

                {/* Card BPJS */}
                <div className="p-2 rounded-2 border" style={{ background: '#f8fafc', borderColor: '#e2e8f0' }}>
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div>
                      <span className="fw-bold text-success d-block" style={{ fontSize: '0.8rem' }}>
                        2. Laporan Tagihan BPJS Kesehatan
                      </span>
                      <span className="text-muted" style={{ fontSize: '0.72rem' }}>
                        {prosesTagihResult.bpjs?.count_kuitansi || 0} Kuitansi &bull; {prosesTagihResult.bpjs?.count_transaksi || 0} Transaksi &bull; 
                        <strong className="text-dark ms-1">Rp {(prosesTagihResult.bpjs?.total_nominal || 0).toLocaleString('id-ID')}</strong>
                      </span>
                    </div>
                    <div className="d-flex gap-1">
                      <Button
                        variant="primary"
                        size="sm"
                        className="d-flex align-items-center gap-1 py-1 px-2 fw-semibold"
                        style={{ fontSize: '0.72rem' }}
                        onClick={() => handlePreviewPdfTagih('bpjs')}
                      >
                        <i className="bi bi-file-earmark-pdf-fill"></i> Lihat PDF
                      </Button>
                      <Button
                        variant="success"
                        size="sm"
                        className="d-flex align-items-center gap-1 py-1 px-2 fw-semibold"
                        style={{ fontSize: '0.72rem' }}
                        onClick={() => handleDownloadExcelTagih('bpjs')}
                      >
                        <i className="bi bi-file-earmark-excel-fill"></i> Excel
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Bottom Action Buttons Sesuai Layout VB (PROSES & KELUAR) */}
            <div className="d-flex justify-content-end gap-2 pt-2 border-top" style={{ borderColor: '#94a3b8' }}>
              {/* TOMBOL PROSES */}
              <button
                type="button"
                disabled={isProsesTagihLoading}
                onClick={handleEksekusiProsesTagih}
                style={vbBtnStyle}
                title="Mulai Proses Laporan Tagih Piutang"
              >
                {isProsesTagihLoading ? (
                  <Spinner size="sm" animation="border" className="me-1 text-primary" />
                ) : (
                  <i className="bi bi-printer-fill text-primary fs-6 me-1"></i>
                )}
                <span><u>P</u>ROSES</span>
              </button>

              {/* TOMBOL KELUAR */}
              <button
                type="button"
                disabled={isProsesTagihLoading}
                onClick={() => setShowModalProsesTagih(false)}
                style={vbBtnBersihStyle}
                title="Keluar dari Dialog"
              >
                <i className="bi bi-x-circle-fill text-danger fs-6 me-1"></i>
                <span><u>K</u>ELUAR</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* ══ MODAL LAPORAN JURNAL DIBAYAR (KALKULATOR_KEUANGAN) ══ */}
      <Modal
        show={showModalJurnalDibayar}
        onHide={() => !isLoadingJurnal && setShowModalJurnalDibayar(false)}
        centered
        backdrop="static"
        dialogClassName="modal-kalkulator-keuangan"
      >
        <style>{`
          .modal-kalkulator-keuangan .modal-dialog {
            max-width: 740px !important;
            width: 95% !important;
          }
          .modal-kalkulator-keuangan .modal-content {
            background: transparent !important;
            border: none !important;
            box-shadow: none !important;
            padding: 0 !important;
          }
        `}</style>
        <div style={{
          width: '100%',
          maxWidth: '730px',
          margin: '0 auto',
          backgroundColor: '#dcdcd8',
          border: '2px solid #555555',
          borderRadius: '4px',
          boxShadow: '0 12px 30px rgba(0,0,0,0.55)',
          overflow: 'hidden',
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
        }}>
          {/* Top Window Title Bar */}
          <div style={{
            background: '#3c3b37',
            color: '#ffffff',
            padding: '4px 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid #222'
          }}>
            <div className="d-flex align-items-center gap-2">
              <span
                onClick={() => !isLoadingJurnal && setShowModalJurnalDibayar(false)}
                style={{
                  width: '13px',
                  height: '13px',
                  borderRadius: '50%',
                  backgroundColor: '#e74c3c',
                  border: '1px solid #c0392b',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontSize: '9px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  lineHeight: 1
                }}
                title="Tutup"
              >
                ×
              </span>
              <span
                onClick={() => !isLoadingJurnal && setShowModalJurnalDibayar(false)}
                style={{
                  width: '13px',
                  height: '13px',
                  borderRadius: '50%',
                  backgroundColor: '#95a5a6',
                  border: '1px solid #7f8c8d',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  lineHeight: 1
                }}
                title="Minimize"
              >
                -
              </span>
              <span style={{ fontWeight: 'bold', fontSize: '11.5px', letterSpacing: '0.6px', color: '#e5e7eb', marginLeft: '6px' }}>
                Laporan Jurnal dibayar
              </span>
            </div>
          </div>

          {/* Window Content Body */}
          <div style={{ padding: '8px', backgroundColor: '#dcdcd8' }}>
            {/* Header Banner */}
            <div style={{
              background: '#002f6c',
              color: '#ffffff',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '12px',
              padding: '5px 10px',
              letterSpacing: '0.6px',
              border: '1px solid #001f4d',
              marginBottom: '6px'
            }}>
              LAPORAN DAN JURNAL PENGELUARAN
            </div>

            {/* Inner Form Group Box with Bevel */}
            <div style={{
              border: '2px groove #ffffff',
              padding: '8px',
              backgroundColor: '#dcdcd8',
              marginBottom: '8px'
            }}>
              {/* Row 1: PERIODE PEMBAYARAN */}
              <div style={{
                display: 'flex',
                alignItems: 'stretch',
                border: '1px solid #475569',
                backgroundColor: '#ffffff'
              }}>
                <div style={{
                  background: '#002f6c',
                  color: '#ffffff',
                  fontWeight: 'bold',
                  fontSize: '10.5px',
                  padding: '5px 12px',
                  letterSpacing: '0.4px',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  PERIODE PEMBAYARAN
                </div>

                <div style={{ flex: 1, background: '#ffff33', position: 'relative' }}>
                  <input
                    type="date"
                    value={periodeJurnal1}
                    onChange={(e) => setPeriodeJurnal1(e.target.value)}
                    disabled={isLoadingJurnal}
                    style={{
                      width: '100%',
                      height: '28px',
                      background: '#ffff33',
                      border: 'none',
                      outline: 'none',
                      fontWeight: 'bold',
                      fontSize: '11px',
                      textAlign: 'center',
                      color: '#000000',
                      cursor: 'pointer',
                      padding: '2px 4px'
                    }}
                    title="Tanggal Awal (Default: Awal Bulan Berjalan)"
                  />
                </div>

                <div style={{
                  background: '#002f6c',
                  color: '#ffffff',
                  fontWeight: 'bold',
                  fontSize: '10.5px',
                  padding: '5px 12px',
                  letterSpacing: '0.4px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  S/D
                </div>

                <div style={{ flex: 1, background: '#ffffff', position: 'relative' }}>
                  <input
                    type="date"
                    value={periodeJurnal2}
                    onChange={(e) => setPeriodeJurnal2(e.target.value)}
                    disabled={isLoadingJurnal}
                    style={{
                      width: '100%',
                      height: '28px',
                      background: '#ffffff',
                      border: 'none',
                      outline: 'none',
                      fontWeight: 'bold',
                      fontSize: '11px',
                      textAlign: 'center',
                      color: '#000000',
                      cursor: 'pointer',
                      padding: '2px 4px'
                    }}
                    title="Tanggal Akhir (Default: Hari Ini)"
                  />
                </div>
              </div>

              {/* Row 2: Checkbox Sinkronisasi Otomatis */}
              <div className="d-flex align-items-center justify-content-between mt-2 pt-1 border-top border-secondary border-opacity-25 px-1">
                <label className="d-flex align-items-center gap-2 mb-0 fw-semibold text-dark" style={{ fontSize: '11px', cursor: 'pointer', userSelect: 'none' }}>
                  <input
                    type="checkbox"
                    checked={autoProcessJurnal}
                    onChange={(e) => setAutoProcessJurnal(e.target.checked)}
                    disabled={isLoadingJurnal}
                    style={{ cursor: 'pointer', width: '14px', height: '14px' }}
                  />
                  <span>Sinkronisasi Otomatis Data Terbaru (auto_process)</span>
                </label>
                <span className="badge bg-secondary bg-opacity-25 text-dark border px-2 py-1" style={{ fontSize: '9.5px' }}>
                  Default: Aktif
                </span>
              </div>

              {/* Row 3: Loading Indicator / Result Summary */}
              {isLoadingJurnal && (
                <div className="mt-2 p-2 bg-white border rounded text-center shadow-sm">
                  <div className="d-flex align-items-center justify-content-center gap-2 text-primary fw-bold" style={{ fontSize: '11px' }}>
                    <Spinner animation="border" size="sm" />
                    <span>{statusJurnalMsg || 'Sedang memproses data jurnal transaksi...'}</span>
                  </div>
                  <div className="progress mt-2" style={{ height: '6px' }}>
                    <div className="progress-bar progress-bar-striped progress-bar-animated bg-primary" style={{ width: '100%' }}></div>
                  </div>
                  <div className="text-muted mt-1" style={{ fontSize: '10px' }}>
                    Memproses Jurnal Pengeluaran lalu melanjutkan ke Rekapitulasi Jurnal Kasir...
                  </div>
                </div>
              )}

              {!isLoadingJurnal && (jurnalDataResult || rekapJurnalKasirResult) && (
                <div className="mt-2 p-2 bg-white border rounded shadow-sm" style={{ fontSize: '11px' }}>
                  {jurnalDataResult && (
                    <div className="border-bottom pb-1 mb-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-semibold text-dark">
                          <i className="bi bi-check-circle-fill text-success me-1"></i>1. Jurnal Pengeluaran (Dibayar):
                        </span>
                        <span className="fw-bold text-dark">{jurnalDataResult.count || 0} baris</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mt-1">
                        <span className="text-muted ps-3">Total Nilai Pengeluaran:</span>
                        <span className="fw-bold text-success">
                          {formatRp(jurnalDataResult.grand_total?.total || 0)}
                        </span>
                      </div>
                    </div>
                  )}

                  {rekapJurnalKasirResult && (
                    <div className="pt-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-semibold text-dark">
                          <i className="bi bi-check-circle-fill text-primary me-1"></i>2. Rekapitulasi Jurnal Kasir:
                        </span>
                        <span className="fw-bold text-dark">{rekapJurnalKasirResult.count || 0} transaksi</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mt-1">
                        <span className="text-muted ps-3">Total Pendapatan Kasir:</span>
                        <span className="fw-bold text-primary">
                          {formatRp(rekapJurnalKasirResult.grand_total?.total || 0)}
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="mt-2 pt-1 border-top d-flex justify-content-end">
                    <button
                      type="button"
                      onClick={() => {
                        setShowModalJurnalDibayar(false);
                        navigate('/LaporanRekapJurnalKasir');
                      }}
                      className="btn btn-outline-primary btn-sm py-0 px-2 fw-semibold"
                      style={{ fontSize: '10px' }}
                    >
                      <i className="bi bi-box-arrow-up-right me-1"></i>Buka Tabel Detail Rekap Kasir
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Bottom Controls */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
              <input
                type="text"
                readOnly
                value={statusJurnalMsg}
                placeholder=""
                style={{
                  flex: 1,
                  minWidth: 0,
                  height: '30px',
                  backgroundColor: '#ffffff',
                  border: '1px solid #708090',
                  boxShadow: 'inset 1px 1px 2px rgba(0,0,0,0.15)',
                  padding: '2px 8px',
                  fontSize: '11px',
                  color: '#334155',
                  outline: 'none'
                }}
              />

              {/* TAMPILKAN DATA BUTTON */}
              <button
                type="button"
                onClick={() => handleFetchJurnalDibayar(false)}
                disabled={isLoadingJurnal}
                style={{
                  background: 'linear-gradient(180deg, #ffffff 0%, #ececec 45%, #d4d0c8 100%)',
                  border: '1px solid #708090',
                  boxShadow: 'inset 1px 1px 0px #fff, 1px 1px 2px rgba(0,0,0,0.2)',
                  padding: '3px 14px',
                  height: '30px',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  color: '#0f172a',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: isLoadingJurnal ? 'not-allowed' : 'pointer',
                  borderRadius: '3px',
                  whiteSpace: 'nowrap',
                  flexShrink: 0
                }}
                title="Tampilkan dan Sinkronisasi Data Jurnal"
              >
                {isLoadingJurnal ? <Spinner animation="border" size="sm" style={{ width: '13px', height: '13px' }} /> : <i className="bi bi-search text-primary" style={{ fontSize: '12px' }}></i>}
                <span><u>T</u>AMPILKAN DATA</span>
              </button>

              {/* UNDUH EXCEL BUTTON */}
              <button
                type="button"
                onClick={handleUnduhExcelJurnal}
                disabled={isLoadingJurnal}
                style={{
                  background: 'linear-gradient(180deg, #ecfdf5 0%, #d1fae5 45%, #a7f3d0 100%)',
                  border: '1px solid #059669',
                  boxShadow: 'inset 1px 1px 0px #fff, 1px 1px 2px rgba(0,0,0,0.2)',
                  padding: '3px 14px',
                  height: '30px',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  color: '#065f46',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: isLoadingJurnal ? 'not-allowed' : 'pointer',
                  borderRadius: '3px',
                  whiteSpace: 'nowrap',
                  flexShrink: 0
                }}
                title="Unduh Berkas Excel Laporan Jurnal Dibayar (.xlsx)"
              >
                <i className="bi bi-file-earmark-excel-fill text-success" style={{ fontSize: '14px' }}></i>
                <span>UNDUH <u>E</u>XCEL</span>
              </button>

              {/* KELUAR BUTTON */}
              <button
                type="button"
                onClick={() => setShowModalJurnalDibayar(false)}
                disabled={isLoadingJurnal}
                style={{
                  background: 'linear-gradient(180deg, #ffffff 0%, #ececec 45%, #d4d0c8 100%)',
                  border: '1px solid #708090',
                  boxShadow: 'inset 1px 1px 0px #fff, 1px 1px 2px rgba(0,0,0,0.2)',
                  padding: '3px 14px',
                  height: '30px',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  color: '#000000',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  borderRadius: '3px',
                  whiteSpace: 'nowrap',
                  flexShrink: 0
                }}
                title="Keluar dari Jendela"
              >
                <i className="bi bi-x-circle-fill text-danger" style={{ fontSize: '13px' }}></i>
                <span>KELUAR</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* ══ MODAL MESSAGEBOX MODERN & PROFESIONAL ══ */}
      <Modal 
        show={messageBox.show} 
        onHide={closeMsg} 
        centered 
        backdrop="static"
        keyboard={true}
        contentClassName="border-0 shadow-lg"
        style={{ zIndex: 1060 }}
      >
        <div style={{
          borderRadius: '16px',
          overflow: 'hidden',
          background: '#ffffff',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
        }}>
          {/* Top color indicator stripe */}
          <div style={{
            height: '6px',
            background: messageBox.type === 'success' 
              ? 'linear-gradient(90deg, #10b981 0%, #059669 100%)' 
              : messageBox.type === 'danger'
              ? 'linear-gradient(90deg, #ef4444 0%, #b91c1c 100%)'
              : messageBox.type === 'warning' || messageBox.type === 'confirm'
              ? 'linear-gradient(90deg, #f59e0b 0%, #d97706 100%)'
              : 'linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%)'
          }} />

          <Modal.Body className="text-center p-4">
            <div className="d-flex justify-content-center mb-3">
              <div style={{
                width: '68px',
                height: '68px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: messageBox.type === 'success'
                  ? '#ecfdf5'
                  : messageBox.type === 'danger'
                  ? '#fef2f2'
                  : messageBox.type === 'warning' || messageBox.type === 'confirm'
                  ? '#fffbeb'
                  : '#eff6ff',
                border: messageBox.type === 'success'
                  ? '2px solid #a7f3d0'
                  : messageBox.type === 'danger'
                  ? '2px solid #fecaca'
                  : messageBox.type === 'warning' || messageBox.type === 'confirm'
                  ? '2px solid #fde68a'
                  : '2px solid #bfdbfe',
                boxShadow: '0 4px 12px rgba(0,0,0,0.06)'
              }}>
                {messageBox.type === 'success' && (
                  <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '2.2rem' }}></i>
                )}
                {(messageBox.type === 'warning' || messageBox.type === 'confirm') && (
                  <i className="bi bi-exclamation-triangle-fill text-warning" style={{ fontSize: '2.2rem', color: '#d97706' }}></i>
                )}
                {messageBox.type === 'danger' && (
                  <i className="bi bi-x-circle-fill text-danger" style={{ fontSize: '2.2rem' }}></i>
                )}
                {messageBox.type === 'info' && (
                  <i className="bi bi-info-circle-fill text-primary" style={{ fontSize: '2.2rem' }}></i>
                )}
              </div>
            </div>

            <h5 className="fw-bold mb-2" style={{ color: '#0f172a', fontSize: '1.15rem', letterSpacing: '-0.01em' }}>
              {messageBox.title}
            </h5>

            <p className="text-muted mb-4" style={{ fontSize: '0.88rem', lineHeight: '1.55', whiteSpace: 'pre-line' }}>
              {messageBox.message}
            </p>

            <div className="d-flex justify-content-center gap-2">
              {messageBox.type === 'confirm' && (
                <Button
                  variant="outline-secondary"
                  className="px-3 py-2 fw-semibold"
                  style={{ borderRadius: '8px', fontSize: '0.82rem', minWidth: '100px' }}
                  onClick={() => {
                    closeMsg();
                    if (messageBox.onCancel) messageBox.onCancel();
                  }}
                >
                  {messageBox.cancelText || 'Batal'}
                </Button>
              )}
              <Button
                variant={messageBox.type === 'danger' ? 'danger' : messageBox.type === 'success' ? 'success' : 'primary'}
                className="px-4 py-2 fw-bold text-white shadow-sm"
                style={{
                  borderRadius: '8px',
                  fontSize: '0.82rem',
                  minWidth: messageBox.type === 'confirm' ? '120px' : '140px',
                  background: messageBox.type === 'success'
                    ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                    : messageBox.type === 'danger'
                    ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
                    : messageBox.type === 'warning' || messageBox.type === 'confirm'
                    ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
                    : 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
                  border: 'none'
                }}
                onClick={() => {
                  const action = messageBox.onConfirm;
                  closeMsg();
                  if (action) action();
                }}
                autoFocus
              >
                {messageBox.confirmText || 'OK, Mengerti'}
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>

    </div>
  );
}

export default RekapPiutang;
